import { defineComponent as w, computed as C, openBlock as a, createElementBlock as l, normalizeClass as p, renderSlot as f, createElementVNode as o, mergeProps as U, ref as M, watch as S, withDirectives as D, vModelDynamic as Jt, isRef as Xt, getCurrentInstance as Yt, onMounted as te, nextTick as ee, unref as u, getCurrentScope as oe, onScopeDispose as se, useSlots as rt, createVNode as I, createCommentVNode as x, createBlock as A, resolveDynamicComponent as dt, toDisplayString as y, createStaticVNode as V, Fragment as H, createTextVNode as R, withModifiers as $t, withCtx as F, vModelText as wt, renderList as L, vModelCheckbox as K, vModelSelect as kt, resolveComponent as Ct, toRefs as P, vModelRadio as ne } from "vue";
const ae = ["data-test-id", "disabled"], ct = /* @__PURE__ */ w({
  __name: "cl-button",
  props: {
    dataTestId: { default: "" },
    variant: { default: "default" },
    size: { default: "medium" },
    fullwidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = () => {
      n("on-click");
    }, r = {
      default: "tw-text-dorian-gray-900 tw-bg-white hover:tw-bg-dorian-gray-50/20 active:tw-bg-dorian-gray-50/60 focus:tw-outline-dorian-gray-50 disabled:tw-bg-dorian-gray-200/60 disabled:tw-text-white dark:disabled:tw-text-dorian-gray-200",
      secondary: "tw-text-white tw-bg-secondary-500 hover:tw-bg-secondary-600 active:tw-bg-secondary-700 focus:tw-outline-secondary-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      "secondary-outline": "tw-text-secondary-500 tw-bg-transparent tw-border-0 tw-ring-2 tw-ring-inset tw-ring-secondary-500 enabled:hover:tw-bg-secondary-600 enabled:hover:tw-ring-secondary-600 enabled:hover:tw-text-white enabled:active:tw-bg-secondary-600 enabled:active:tw-text-white enabled:focus:tw-outline-secondary-500/30 disabled:tw-ring-dorian-gray-200/60 disabled:tw-text-dorian-gray-200/60 disabled:tw-bg-transparent",
      "secondary-ghost": "tw-text-secondary-500 tw-bg-transparent tw-border-0 tw-ring-0 enabled:hover:tw-bg-dorian-gray-50 enabled:hover:tw-text-secondary-500 enabled:active:tw-bg-secondary-600 enabled:active:tw-text-white enabled:focus:tw-outline-secondary-500/30 disabled:tw-ring-dorian-gray-200/60 disabled:tw-text-dorian-gray-200/60 disabled:tw-bg-transparent",
      info: "tw-text-white tw-bg-info-500 hover:tw-bg-info-600 active:tw-bg-info-700 focus:tw-outline-info-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      success: "tw-text-white tw-bg-success-500 hover:tw-bg-success-600 active:tw-bg-success-700 focus:tw-outline-success-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      warning: "tw-text-white tw-bg-warning-500 hover:tw-bg-warning-600 active:tw-bg-warning-700 focus:tw-outline-warning-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      danger: "tw-text-white tw-bg-danger-500 hover:tw-bg-danger-600 active:tw-bg-danger-700 focus:tw-outline-danger-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      "danger-outline": "tw-text-danger-500 tw-bg-transparent tw-border-0 tw-ring-2 tw-ring-inset tw-ring-danger-500 enabled:hover:tw-bg-danger-600 enabled:hover:tw-ring-danger-600 enabled:hover:tw-text-white enabled:active:tw-bg-danger-600 enabled:active:tw-text-white enabled:focus:tw-outline-danger-500/30 disabled:tw-ring-dorian-gray-200/60 disabled:tw-text-dorian-gray-200/60 disabled:tw-bg-transparent",
      "link-secondary": "tw-bg-none tw-text-secondary-500 hover:tw-text-secondary-600 active:tw-text-secondary-800 focus:tw-outline-secondary-500/30",
      "i-am-the-danger": "tw-bg-none tw-text-danger-500 hover:tw-text-danger-600 active:tw-text-danger-800 focus:tw-outline-danger-500/30"
    }, i = {
      small: "tw-text-sm tw-py-1 tw-px-2",
      medium: "tw-text-base tw-py-2 tw-px-6",
      large: "tw-text-lg tw-py-3 tw-px-10"
    }, c = C(() => [i[e.size], r[e.variant]]);
    return (h, b) => (a(), l("button", {
      class: p(["tw-m-1 tw-items-center tw-rounded tw-font-medium tw-outline-none tw-outline-offset-0 tw-transition-all focus:tw-outline-4 disabled:tw-cursor-not-allowed", [
        c.value,
        e.fullwidth ? "tw-flex tw-w-full tw-justify-center" : "tw-inline-flex"
      ]]),
      "data-test-id": e.dataTestId,
      disabled: e.disabled,
      onClick: d
    }, [
      f(h.$slots, "default")
    ], 10, ae));
  }
}), j = (s, t) => {
  const e = s.__vccOpts || s;
  for (const [n, d] of t)
    e[n] = d;
  return e;
}, le = {}, re = {
  class: "tw-mb-4 tw-flex tw-flex-col",
  role: "group"
};
function ie(s, t) {
  return a(), l("div", re, [
    f(s.$slots, "default")
  ]);
}
const bw = /* @__PURE__ */ j(le, [["render", ie]]), de = { class: "tw-relative" }, ce = ["for"], vw = /* @__PURE__ */ w({
  __name: "cl-form-label",
  props: {
    labelFor: {},
    position: { default: "top" }
  },
  setup(s) {
    const t = {
      top: "tw-mb-1 tw-block tw-text-base tw-font-normal tw-text-dorian-gray-500",
      border: "tw--top-3.5 tw-absolute tw-left-6 tw-z-10 tw-h-5 tw-bg-white tw-px-1 tw-text-dorian-gray-200"
    }, e = s, n = C(() => [t[e.position]]);
    return (d, r) => (a(), l("div", de, [
      o("label", U({
        for: e.labelFor,
        class: n.value
      }, d.$attrs), [
        f(d.$slots, "default")
      ], 16, ce)
    ]));
  }
}), we = ["id", "name", "type", "autofocus", "disabled", "readonly", "placeholder", "data-test-id", "step", "min", "max", "maxlength"], he = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", ue = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", pe = "read-only:tw-cursor-default read-only:tw-bg-dorian-gray-50 read-only:tw-text-dorian-gray-500/50 read-only:tw-outline-none", mw = /* @__PURE__ */ w({
  __name: "cl-form-input",
  props: {
    inputRef: { default: void 0 },
    id: {},
    name: {},
    value: {},
    size: { default: "medium" },
    type: { default: "text" },
    placeholder: { default: "" },
    state: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 },
    testId: { default: "" },
    step: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    maxlength: { default: void 0 }
  },
  emits: ["update:value", "on-blur", "on-keyup", "on-keydown", "on-paste"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = M(e.value), r = {
      small: "tw-text-sm tw-py-1 tw-px-3",
      medium: "tw-text-base tw-py-2 tw-px-3",
      large: "tw-text-lg tw-py-3 tw-px-3"
    }, i = {
      none: "tw-border-dorian-gray-100/80",
      valid: "tw-border-success-500",
      error: "tw-border-danger-500"
    }, c = C(() => [
      r[e.size],
      e.state === null ? i.none : e.state ? i.valid : i.error,
      he,
      ue,
      pe
    ]);
    S(
      () => e.value,
      () => {
        d.value = e.value;
      }
    ), S(d, (v) => {
      n("update:value", v);
    });
    const h = () => {
      n("on-blur");
    }, b = (v) => {
      n("on-keyup", v);
    }, m = (v) => {
      n("on-keydown", v);
    }, $ = (v) => {
      n("on-paste", v);
    };
    return (v, B) => D((a(), l("input", {
      id: e.id,
      ref: v.inputRef,
      "onUpdate:modelValue": B[0] || (B[0] = (T) => d.value = T),
      class: p(["tw-block tw-w-full tw-rounded tw-border tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", [c.value]]),
      name: e.name,
      type: e.type,
      autofocus: e.autofocus,
      disabled: e.disabled,
      readonly: e.readonly,
      placeholder: e.placeholder,
      "data-test-id": e.testId,
      step: e.step,
      min: e.min,
      max: e.max,
      maxlength: e.maxlength,
      onBlur: h,
      onKeyup: b,
      onKeydown: m,
      onPaste: $
    }, null, 42, we)), [
      [Jt, d.value]
    ]);
  }
}), _e = {
  class: "tw-inline-block",
  role: "status"
}, fe = /* @__PURE__ */ o("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1), ge = /* @__PURE__ */ o("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1), be = [
  fe,
  ge
], ve = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Loading...", -1), yw = /* @__PURE__ */ w({
  __name: "cl-spinner",
  props: {
    variant: { default: "default" },
    size: { default: "medium" }
  },
  setup(s) {
    const t = s, e = {
      default: "tw-fill-dorian-gray-500",
      secondary: "tw-fill-secondary-500",
      info: "tw-fill-info-500",
      success: "tw-fill-success-500",
      warning: "tw-fill-warning-500",
      danger: "tw-fill-danger-500"
    }, n = {
      small: "tw-w-4 tw-h-4",
      medium: "tw-w-6 tw-h-6",
      large: "tw-w-8 tw-h-8",
      xl: "tw-w-10 tw-h-10"
    }, d = C(() => [n[t.size], e[t.variant]]);
    return (r, i) => (a(), l("div", _e, [
      (a(), l("svg", {
        "aria-hidden": "true",
        class: p(["tw-m-1 tw-inline tw-animate-spin tw-text-dorian-gray-50", d.value]),
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, be, 2)),
      ve
    ]));
  }
}), me = {}, ye = { class: "tw-mb-6 tw-mt-6 tw-border-dorian-gray-100" };
function xe(s, t) {
  return a(), l("hr", ye);
}
const xw = /* @__PURE__ */ j(me, [["render", xe]]), $w = /* @__PURE__ */ w({
  __name: "cl-p",
  props: {
    weight: { default: "normal" },
    size: { default: "base" }
  },
  setup(s) {
    const t = s, e = {
      xs: "tw-text-xs",
      sm: "tw-text-sm",
      base: "tw-text-base",
      lg: "tw-text-lg"
    }, n = {
      thin: "tw-font-thin",
      extralight: "tw-font-extralight",
      light: "tw-font-light",
      normal: "tw-font-normal",
      medium: "tw-font-medium"
    }, d = C(() => [
      "cl-p tw-mb-3 tw-text-dorian-gray-500",
      e[t.size],
      n[t.weight]
    ]);
    return (r, i) => (a(), l("p", {
      class: p(d.value)
    }, [
      f(r.$slots, "default")
    ], 2));
  }
});
var _t;
const Mt = typeof window < "u", $e = (s) => typeof s == "string", Bt = () => {
}, ke = Mt && ((_t = window == null ? void 0 : window.navigator) == null ? void 0 : _t.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function lt(s) {
  return typeof s == "function" ? s() : u(s);
}
function Ce(s) {
  return s;
}
function Me(s) {
  return oe() ? (se(s), !0) : !1;
}
function Be(s, t = !0) {
  Yt() ? te(s) : t ? s() : ee(s);
}
function Ie(s = !1, t = {}) {
  const {
    truthyValue: e = !0,
    falsyValue: n = !1
  } = t, d = Xt(s), r = M(s);
  function i(c) {
    if (arguments.length)
      return r.value = c, r.value;
    {
      const h = lt(e);
      return r.value = r.value === h ? lt(n) : h, r.value;
    }
  }
  return d ? i : [r, i];
}
function tt(s) {
  var t;
  const e = lt(s);
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
const ht = Mt ? window : void 0;
function et(...s) {
  let t, e, n, d;
  if ($e(s[0]) || Array.isArray(s[0]) ? ([e, n, d] = s, t = ht) : [t, e, n, d] = s, !t)
    return Bt;
  Array.isArray(e) || (e = [e]), Array.isArray(n) || (n = [n]);
  const r = [], i = () => {
    r.forEach((m) => m()), r.length = 0;
  }, c = (m, $, v, B) => (m.addEventListener($, v, B), () => m.removeEventListener($, v, B)), h = S(() => [tt(t), lt(d)], ([m, $]) => {
    i(), m && r.push(...e.flatMap((v) => n.map((B) => c(m, v, B, $))));
  }, { immediate: !0, flush: "post" }), b = () => {
    h(), i();
  };
  return Me(b), b;
}
let ft = !1;
function W(s, t, e = {}) {
  const { window: n = ht, ignore: d = [], capture: r = !0, detectIframe: i = !1 } = e;
  if (!n)
    return;
  ke && !ft && (ft = !0, Array.from(n.document.body.children).forEach((v) => v.addEventListener("click", Bt)));
  let c = !0;
  const h = (v) => d.some((B) => {
    if (typeof B == "string")
      return Array.from(n.document.querySelectorAll(B)).some((T) => T === v.target || v.composedPath().includes(T));
    {
      const T = tt(B);
      return T && (v.target === T || v.composedPath().includes(T));
    }
  }), m = [
    et(n, "click", (v) => {
      const B = tt(s);
      if (!(!B || B === v.target || v.composedPath().includes(B))) {
        if (v.detail === 0 && (c = !h(v)), !c) {
          c = !0;
          return;
        }
        t(v);
      }
    }, { passive: !0, capture: r }),
    et(n, "pointerdown", (v) => {
      const B = tt(s);
      B && (c = !v.composedPath().includes(B) && !h(v));
    }, { passive: !0 }),
    i && et(n, "blur", (v) => {
      var B;
      const T = tt(s);
      ((B = n.document.activeElement) == null ? void 0 : B.tagName) === "IFRAME" && !(T != null && T.contains(n.document.activeElement)) && t(v);
    })
  ].filter(Boolean);
  return () => m.forEach((v) => v());
}
const gt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, bt = "__vueuse_ssr_handlers__";
gt[bt] = gt[bt] || {};
var vt;
(function(s) {
  s.UP = "UP", s.RIGHT = "RIGHT", s.DOWN = "DOWN", s.LEFT = "LEFT", s.NONE = "NONE";
})(vt || (vt = {}));
var ze = Object.defineProperty, mt = Object.getOwnPropertySymbols, Te = Object.prototype.hasOwnProperty, He = Object.prototype.propertyIsEnumerable, yt = (s, t, e) => t in s ? ze(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e, Se = (s, t) => {
  for (var e in t || (t = {}))
    Te.call(t, e) && yt(s, e, t[e]);
  if (mt)
    for (var e of mt(t))
      He.call(t, e) && yt(s, e, t[e]);
  return s;
};
const je = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Se({
  linear: Ce
}, je);
function Le(s = {}) {
  const {
    window: t = ht,
    initialWidth: e = 1 / 0,
    initialHeight: n = 1 / 0,
    listenOrientation: d = !0,
    includeScrollbar: r = !0
  } = s, i = M(e), c = M(n), h = () => {
    t && (r ? (i.value = t.innerWidth, c.value = t.innerHeight) : (i.value = t.document.documentElement.clientWidth, c.value = t.document.documentElement.clientHeight));
  };
  return h(), Be(h), et("resize", h, { passive: !0 }), d && et("orientationchange", h, { passive: !0 }), { width: i, height: c };
}
const Ve = { class: "tw-mb-3 tw-flex tw-items-center tw-p-4" }, Pe = {
  key: 0,
  class: "tw-ml-3 tw-flex tw-w-full tw-justify-center",
  "data-test-id": "company-logo"
}, Ae = { href: "/" }, Oe = {
  key: 1,
  class: "tw-ml-3 tw-p-4",
  "data-test-id": "products-section"
}, De = {
  key: 2,
  class: "tw-ml-3 tw-p-4",
  "data-test-id": "users-section"
}, Ne = {
  key: 0,
  "data-test-id": "dropdown-select"
}, Fe = /* @__PURE__ */ o("div", { class: "tw-devider tw-my-2 tw-px-4 tw-py-2" }, [
  /* @__PURE__ */ o("hr", { class: "tw-border-aside-400 dark:tw-border-dorian-gray-100" })
], -1), Ee = { class: "tw-mt-auto tw-p-4" }, Ze = {
  key: 0,
  class: "tw-mb-3",
  "data-test-id": "info-section"
}, kw = /* @__PURE__ */ w({
  __name: "cl-sidebar",
  setup(s) {
    const t = rt(), e = M(!1), { width: n } = Le();
    function d() {
      e.value = !e.value;
    }
    return S(
      n,
      (r) => {
        r > 1024 && e.value && (e.value = !1), r < 1024 && !e.value && (e.value = !0);
      },
      { immediate: !0 }
    ), (r, i) => (a(), l("aside", {
      class: p(["tw-z-30 tw-m-0 tw-flex tw-flex-col tw-bg-aside-600 tw-p-0 tw-align-top tw-text-white tw-transition-all dark:tw-text-dorian-gray-500 max-lg:tw-absolute max-lg:tw-bottom-0 max-lg:tw-left-0 max-lg:tw-top-0", [e.value ? "tw-w-14" : "tw-min-w-[375px]"]])
    }, [
      o("div", Ve, [
        o("div", null, [
          o("button", {
            "data-test-id": "toggle-btn",
            onClick: d
          }, [
            I(u(lo), {
              width: "24px",
              height: "24px"
            })
          ])
        ]),
        u(t)["company-logo"] ? (a(), l("div", Pe, [
          o("a", Ae, [
            f(r.$slots, "company-logo", { isClosed: e.value })
          ])
        ])) : x("", !0),
        u(t)["products-section"] ? (a(), l("div", Oe, [
          f(r.$slots, "products-section", { isClosed: e.value })
        ])) : x("", !0),
        u(t)["users-section"] ? (a(), l("div", De, [
          f(r.$slots, "users-section", { isClosed: e.value })
        ])) : x("", !0)
      ]),
      u(t)["dropdown-select"] ? (a(), l("div", Ne, [
        f(r.$slots, "dropdown-select", { isClosed: e.value })
      ])) : x("", !0),
      Fe,
      u(t)["side-nav"] ? (a(), l("div", {
        key: 1,
        "data-test-id": "side-nav",
        class: p(["tw-relative tw-my-3 tw-h-full", !e.value && "tw-overflow-y-auto"])
      }, [
        f(r.$slots, "side-nav", { isClosed: e.value })
      ], 2)) : x("", !0),
      o("div", Ee, [
        u(t)["info-section"] ? (a(), l("div", Ze, [
          f(r.$slots, "info-section")
        ])) : x("", !0)
      ])
    ], 2));
  }
}), Re = {
  key: 0,
  class: "tw-w-full"
}, Ue = ["href"], We = ["data-test-id"], Ge = {
  key: 1,
  class: "tw-w-full"
}, Qe = ["href"], qe = ["data-test-id"], Ke = { class: "tw-flex tw-flex-nowrap tw-items-center" }, Je = { class: "tw-ml-2" }, Cw = /* @__PURE__ */ w({
  __name: "cl-sidebar-nav-item-parent",
  props: {
    label: {},
    icon: {},
    isClosed: { type: Boolean },
    navigate: {},
    href: {},
    isActive: { type: Boolean },
    dataTestId: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  setup(s) {
    return (t, e) => t.isClosed ? (a(), l("div", Re, [
      o("a", {
        href: t.href,
        class: p({
          "tw-pointer-events-none": t.disabled
        }),
        onClick: e[0] || (e[0] = //@ts-ignore
        (...n) => t.navigate && t.navigate(...n))
      }, [
        o("div", {
          class: p(["tw-flex tw-cursor-pointer tw-items-center tw-gap-4 tw-p-4 hover:tw-bg-aside-400", {
            "tw-bg-aside-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-dorian-gray-500": t.isActive,
            "tw-text-dorian-gray-200": t.disabled
          }]),
          "data-test-id": t.dataTestId
        }, [
          (a(), A(dt(t.icon)))
        ], 10, We)
      ], 10, Ue)
    ])) : (a(), l("div", Ge, [
      o("a", {
        href: t.href,
        class: p({
          "tw-pointer-events-none": t.disabled
        }),
        onClick: e[2] || (e[2] = //@ts-ignore
        (...n) => t.navigate && t.navigate(...n))
      }, [
        o("div", {
          class: p(["tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-4 tw-p-4 hover:tw-bg-aside-400", {
            "tw-bg-aside-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-dorian-gray-500": t.isActive,
            "tw-text-dorian-gray-200": t.disabled
          }]),
          "data-test-id": t.dataTestId,
          onClick: e[1] || (e[1] = //@ts-ignore
          (...n) => t.navigate && t.navigate(...n))
        }, [
          o("div", Ke, [
            (a(), A(dt(t.icon))),
            o("span", Je, y(t.label), 1)
          ]),
          f(t.$slots, "pill")
        ], 10, qe)
      ], 10, Qe)
    ]));
  }
}), Xe = {}, Ye = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  class: "tw-inline-flex tw-h-4 tw-w-4"
}, to = /* @__PURE__ */ o("path", { d: "M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z" }, null, -1), eo = [
  to
];
function oo(s, t) {
  return a(), l("svg", Ye, eo);
}
const Mw = /* @__PURE__ */ j(Xe, [["render", oo]]), so = ["width", "height"], no = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
}, null, -1), ao = [
  no
], lo = /* @__PURE__ */ w({
  __name: "cl-icon-list",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: "tw-inline-flex",
      width: t.width,
      height: t.height
    }, ao, 8, so));
  }
}), ro = ["width", "height"], io = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0v-2z"
}, null, -1), co = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M4.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H14.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
}, null, -1), wo = [
  io,
  co
], Bw = /* @__PURE__ */ w({
  __name: "cl-icon-box-arrow-in-left",
  props: {
    fill: { default: "white" },
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: p(["tw-inline-flex", `tw-fill-${t.fill}`]),
      viewBox: "0 0 16 16",
      width: t.width,
      height: t.height
    }, wo, 10, ro));
  }
}), ho = ["stroke", "width", "height"], uo = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"
}, null, -1), po = [
  uo
], Iw = /* @__PURE__ */ w({
  __name: "cl-icon-arrow-up-right",
  props: {
    width: { default: "16px" },
    height: { default: "16px" },
    stroke: { default: "2" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "tw-inline-flex",
      viewBox: "0 0 16 16",
      stroke: t.stroke,
      width: t.width,
      height: t.height
    }, po, 8, ho));
  }
}), _o = ["width", "height"], fo = /* @__PURE__ */ o("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }, null, -1), go = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
}, null, -1), bo = [
  fo,
  go
], zw = /* @__PURE__ */ w({
  __name: "cl-icon-pencil-square",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "tw-inline-flex",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      width: t.width,
      height: t.height
    }, bo, 8, _o));
  }
}), vo = {}, mo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-dashboard",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, yo = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), xo = /* @__PURE__ */ o("path", { d: "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }, null, -1), $o = /* @__PURE__ */ o("path", { d: "M13.45 11.55l2.05 -2.05" }, null, -1), ko = /* @__PURE__ */ o("path", { d: "M6.4 20a9 9 0 1 1 11.2 0z" }, null, -1), Co = [
  yo,
  xo,
  $o,
  ko
];
function Mo(s, t) {
  return a(), l("svg", mo, Co);
}
const Tw = /* @__PURE__ */ j(vo, [["render", Mo]]), Bo = {}, Io = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-flag-3",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, zo = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), To = /* @__PURE__ */ o("path", { d: "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16" }, null, -1), Ho = [
  zo,
  To
];
function So(s, t) {
  return a(), l("svg", Io, Ho);
}
const Hw = /* @__PURE__ */ j(Bo, [["render", So]]), jo = {}, Lo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-bulb",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Vo = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Po = /* @__PURE__ */ o("path", { d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" }, null, -1), Ao = /* @__PURE__ */ o("path", { d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" }, null, -1), Oo = /* @__PURE__ */ o("path", { d: "M9.7 17l4.6 0" }, null, -1), Do = [
  Vo,
  Po,
  Ao,
  Oo
];
function No(s, t) {
  return a(), l("svg", Lo, Do);
}
const Sw = /* @__PURE__ */ j(jo, [["render", No]]), Fo = {}, Eo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-chart-bar",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Zo = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path><path d="M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path><path d="M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path><path d="M4 20l14 0"></path>', 5), Ro = [
  Zo
];
function Uo(s, t) {
  return a(), l("svg", Eo, Ro);
}
const jw = /* @__PURE__ */ j(Fo, [["render", Uo]]), Wo = {}, Go = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-recharging",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Qo = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M7.038 4.5a9 9 0 0 0 -2.495 2.47"></path><path d="M3.186 10.209a9 9 0 0 0 0 3.508"></path><path d="M4.5 16.962a9 9 0 0 0 2.47 2.495"></path><path d="M10.209 20.814a9 9 0 0 0 3.5 0"></path><path d="M16.962 19.5a9 9 0 0 0 2.495 -2.47"></path><path d="M20.814 13.791a9 9 0 0 0 0 -3.508"></path><path d="M19.5 7.038a9 9 0 0 0 -2.47 -2.495"></path><path d="M13.791 3.186a9 9 0 0 0 -3.508 -.02"></path><path d="M12 8l-2 4h4l-2 4"></path><path d="M12 21a9 9 0 0 0 0 -18"></path>', 11), qo = [
  Qo
];
function Ko(s, t) {
  return a(), l("svg", Go, qo);
}
const Lw = /* @__PURE__ */ j(Wo, [["render", Ko]]), Jo = {}, Xo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-settings",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Yo = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), ts = /* @__PURE__ */ o("path", { d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" }, null, -1), es = /* @__PURE__ */ o("path", { d: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" }, null, -1), os = [
  Yo,
  ts,
  es
];
function ss(s, t) {
  return a(), l("svg", Xo, os);
}
const Vw = /* @__PURE__ */ j(Jo, [["render", ss]]), ns = ["width", "height"], as = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path><path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>', 5), ls = [
  as
], Pw = /* @__PURE__ */ w({
  __name: "tabler-icon-users",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-users",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ls, 8, ns));
  }
}), rs = ["width", "height"], is = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 21l18 0"></path><path d="M5 21v-14l8 -4v18"></path><path d="M19 21v-10l-6 -4"></path><path d="M9 9l0 .01"></path><path d="M9 12l0 .01"></path><path d="M9 15l0 .01"></path><path d="M9 18l0 .01"></path>', 8), ds = [
  is
], Aw = /* @__PURE__ */ w({
  __name: "tabler-icon-building-skyscraper",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-building-skyscraper",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ds, 8, rs));
  }
}), cs = {}, ws = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-briefcase",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, hs = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path><path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"></path><path d="M12 12l0 .01"></path><path d="M3 13a20 20 0 0 0 18 0"></path>', 5), us = [
  hs
];
function ps(s, t) {
  return a(), l("svg", ws, us);
}
const Ow = /* @__PURE__ */ j(cs, [["render", ps]]), _s = ["width", "height"], fs = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), gs = /* @__PURE__ */ o("path", { d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" }, null, -1), bs = /* @__PURE__ */ o("path", { d: "M7 11l5 5l5 -5" }, null, -1), vs = /* @__PURE__ */ o("path", { d: "M12 4l0 12" }, null, -1), ms = [
  fs,
  gs,
  bs,
  vs
], ys = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-download",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ms, 8, _s));
  }
}), xs = ["width", "height"], $s = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M20.985 12.52a9 9 0 1 0 -8.451 8.463"></path><path d="M3.6 9h16.8"></path><path d="M3.6 15h10.9"></path><path d="M11.5 3a17 17 0 0 0 0 18"></path><path d="M12.5 3a16.996 16.996 0 0 1 2.391 11.512"></path><path d="M19 22v-6"></path><path d="M22 19l-3 -3l-3 3"></path>', 8), ks = [
  $s
], Dw = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-world-up",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ks, 8, xs));
  }
}), Cs = ["width", "height"], Ms = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Bs = /* @__PURE__ */ o("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }, null, -1), Is = /* @__PURE__ */ o("path", { d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" }, null, -1), zs = [
  Ms,
  Bs,
  Is
], Ts = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-file",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, zs, 8, Cs));
  }
}), Hs = ["width", "height"], Ss = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), js = /* @__PURE__ */ o("path", { d: "M6 9l6 6l6 -6" }, null, -1), Ls = [
  Ss,
  js
], ot = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-chevron-down",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-chevron-down",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Ls, 8, Hs));
  }
}), Vs = ["width", "height"], Ps = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), As = /* @__PURE__ */ o("path", { d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" }, null, -1), Os = /* @__PURE__ */ o("path", { d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" }, null, -1), Ds = /* @__PURE__ */ o("path", { d: "M16 5l3 3" }, null, -1), Ns = [
  Ps,
  As,
  Os,
  Ds
], Fs = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-edit",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-edit",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Ns, 8, Vs));
  }
}), Es = ["width", "height"], Zs = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Rs = /* @__PURE__ */ o("path", { d: "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z" }, null, -1), Us = /* @__PURE__ */ o("path", { d: "M16 5l3 3" }, null, -1), Ws = /* @__PURE__ */ o("path", { d: "M9 7.07a7 7 0 0 0 1 13.93a7 7 0 0 0 6.929 -6" }, null, -1), Gs = [
  Zs,
  Rs,
  Us,
  Ws
], Nw = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-edit-circle",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-edit-circle",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Gs, 8, Es));
  }
}), Qs = ["width", "height"], qs = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Ks = /* @__PURE__ */ o("path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" }, null, -1), Js = /* @__PURE__ */ o("path", { d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" }, null, -1), Xs = [
  qs,
  Ks,
  Js
], Ys = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-icon-eye",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-eye",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Xs, 8, Qs));
  }
}), tn = {}, en = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-history",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, on = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), sn = /* @__PURE__ */ o("path", { d: "M12 8l0 4l2 2" }, null, -1), nn = /* @__PURE__ */ o("path", { d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" }, null, -1), an = [
  on,
  sn,
  nn
];
function ln(s, t) {
  return a(), l("svg", en, an);
}
const Fw = /* @__PURE__ */ j(tn, [["render", ln]]), rn = {}, dn = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-fork",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, cn = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M16 3h5v5"></path><path d="M8 3h-5v5"></path><path d="M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"></path><path d="M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"></path>', 5), wn = [
  cn
];
function hn(s, t) {
  return a(), l("svg", dn, wn);
}
const Ew = /* @__PURE__ */ j(rn, [["render", hn]]), un = {}, pn = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-fork tw-rotate-90",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, _n = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M16 3h5v5"></path><path d="M8 3h-5v5"></path><path d="M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"></path><path d="M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"></path>', 5), fn = [
  _n
];
function gn(s, t) {
  return a(), l("svg", pn, fn);
}
const Zw = /* @__PURE__ */ j(un, [["render", gn]]), bn = {}, vn = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-report-analytics",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, mn = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path><path d="M9 17v-5"></path><path d="M12 17v-1"></path><path d="M15 17v-3"></path>', 6), yn = [
  mn
];
function xn(s, t) {
  return a(), l("svg", vn, yn);
}
const Rw = /* @__PURE__ */ j(bn, [["render", xn]]), $n = {}, kn = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-shield-check",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Cn = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Mn = /* @__PURE__ */ o("path", { d: "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06" }, null, -1), Bn = /* @__PURE__ */ o("path", { d: "M15 19l2 2l4 -4" }, null, -1), In = [
  Cn,
  Mn,
  Bn
];
function zn(s, t) {
  return a(), l("svg", kn, In);
}
const Uw = /* @__PURE__ */ j($n, [["render", zn]]), Tn = {}, Hn = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-shield-lock",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Sn = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), jn = /* @__PURE__ */ o("path", { d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" }, null, -1), Ln = /* @__PURE__ */ o("path", { d: "M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1), Vn = /* @__PURE__ */ o("path", { d: "M12 12l0 2.5" }, null, -1), Pn = [
  Sn,
  jn,
  Ln,
  Vn
];
function An(s, t) {
  return a(), l("svg", Hn, Pn);
}
const Ww = /* @__PURE__ */ j(Tn, [["render", An]]), On = ["width", "height"], Dn = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Nn = /* @__PURE__ */ o("path", { d: "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" }, null, -1), Fn = /* @__PURE__ */ o("path", { d: "M3 10h18" }, null, -1), En = /* @__PURE__ */ o("path", { d: "M10 3v18" }, null, -1), Zn = [
  Dn,
  Nn,
  Fn,
  En
], Rn = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-table",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-table",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "#353A3F",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Zn, 8, On));
  }
}), Un = ["width", "height"], Wn = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M4 7l16 0"></path><path d="M10 11l0 6"></path><path d="M14 11l0 6"></path><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>', 6), Gn = [
  Wn
], Qn = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-trash",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-trash",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Gn, 8, Un));
  }
}), qn = ["width", "height"], Kn = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Jn = /* @__PURE__ */ o("path", { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1), Xn = /* @__PURE__ */ o("path", { d: "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1), Yn = /* @__PURE__ */ o("path", { d: "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1), ta = [
  Kn,
  Jn,
  Xn,
  Yn
], ea = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-dots-vertical",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-dots-vertical",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ta, 8, qn));
  }
}), oa = ["width", "height"], sa = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), na = /* @__PURE__ */ o("path", { d: "M12 5l0 14" }, null, -1), aa = /* @__PURE__ */ o("path", { d: "M18 13l-6 6" }, null, -1), la = /* @__PURE__ */ o("path", { d: "M6 13l6 6" }, null, -1), ra = [
  sa,
  na,
  aa,
  la
], ia = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-arrow-down",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-arrow-down",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ra, 8, oa));
  }
}), da = ["width", "height"], ca = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), wa = /* @__PURE__ */ o("path", { d: "M12 5l0 14" }, null, -1), ha = /* @__PURE__ */ o("path", { d: "M18 11l-6 -6" }, null, -1), ua = /* @__PURE__ */ o("path", { d: "M6 11l6 -6" }, null, -1), pa = [
  ca,
  wa,
  ha,
  ua
], _a = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-arrow-up",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-arrow-up",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, pa, 8, da));
  }
}), fa = ["width", "height"], ga = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), ba = /* @__PURE__ */ o("path", { d: "M15 6l-6 6l6 6" }, null, -1), va = [
  ga,
  ba
], ma = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-chevron-left",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-chevron-left",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, va, 8, fa));
  }
}), ya = ["width", "height"], xa = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), $a = /* @__PURE__ */ o("path", { d: "M9 6l6 6l-6 6" }, null, -1), ka = [
  xa,
  $a
], It = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-chevron-right",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-chevron-right",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, ka, 8, ya));
  }
}), Ca = ["width", "height"], Ma = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Ba = /* @__PURE__ */ o("path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" }, null, -1), Ia = /* @__PURE__ */ o("path", { d: "M12 9h.01" }, null, -1), za = /* @__PURE__ */ o("path", { d: "M11 12h1v4h1" }, null, -1), Ta = [
  Ma,
  Ba,
  Ia,
  za
], zt = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-info-circle",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-info-circle",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Ta, 8, Ca));
  }
}), Ha = ["width", "height"], Sa = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), ja = /* @__PURE__ */ o("path", { d: "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" }, null, -1), La = /* @__PURE__ */ o("path", { d: "M3 7l9 6l9 -6" }, null, -1), Va = [
  Sa,
  ja,
  La
], Gw = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-mail",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-mail",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Va, 8, Ha));
  }
}), Pa = ["width", "height"], Aa = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Oa = /* @__PURE__ */ o("path", { d: "M18 6l-12 12" }, null, -1), Da = /* @__PURE__ */ o("path", { d: "M6 6l12 12" }, null, -1), Na = [
  Aa,
  Oa,
  Da
], Tt = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-x",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-x",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Na, 8, Pa));
  }
}), Fa = ["width", "height"], Ea = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Za = /* @__PURE__ */ o("path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" }, null, -1), Ra = /* @__PURE__ */ o("path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" }, null, -1), Ua = [
  Ea,
  Za,
  Ra
], Wa = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-user",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-user",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Ua, 8, Fa));
  }
}), Ga = ["width", "height"], Qa = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), qa = /* @__PURE__ */ o("path", { d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" }, null, -1), Ka = /* @__PURE__ */ o("path", { d: "M9 12h12l-3 -3" }, null, -1), Ja = /* @__PURE__ */ o("path", { d: "M18 15l3 -3" }, null, -1), Xa = [
  Qa,
  qa,
  Ka,
  Ja
], Qw = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-logout",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-logout",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Xa, 8, Ga));
  }
}), Ya = ["width", "height"], tl = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), el = /* @__PURE__ */ o("path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }, null, -1), ol = /* @__PURE__ */ o("path", { d: "M9 12l2 2l4 -4" }, null, -1), sl = [
  tl,
  el,
  ol
], nl = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-circle-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-circle-check",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, sl, 8, Ya));
  }
}), al = ["width", "height"], ll = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M15 15l3.35 3.35"></path><path d="M9 15l-3.35 3.35"></path><path d="M5.65 5.65l3.35 3.35"></path><path d="M18.35 5.65l-3.35 3.35"></path>', 7), rl = [
  ll
], qw = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-lifebuoy",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-lifebuoy",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, rl, 8, al));
  }
}), il = ["width", "height"], dl = /* @__PURE__ */ o("ellipse", {
  cx: "46.334",
  cy: "46.6492",
  rx: "46.334",
  ry: "46.6492",
  transform: "matrix(1 0 0 -1 0.666016 93.2969)",
  fill: "#F7F7F7"
}, null, -1), cl = /* @__PURE__ */ o("path", {
  d: "M52.8131 47.926L52.0743 46.1004C40.9919 49.9451 34.4793 43.645 34.4793 36.7182C34.4793 29.3716 40.2021 23.8311 47.7908 23.8311C53.9491 23.8311 58.4173 27.8694 58.4173 33.4326C58.4173 38.8559 54.3481 40.3196 52.3844 40.7099V28.095C41.0474 27.7748 38.9602 35.4467 38.9602 37.8019C38.9602 41.0875 41.1741 43.2951 44.4698 43.2951C47.2064 43.2951 49.1467 41.6283 50.4151 39.9225V42.8608C50.4151 42.8608 60.3879 42.8734 60.3879 33.432C60.3879 26.7271 55.0907 21.8604 47.7914 21.8604C38.3512 21.8604 32.51 29.1352 32.51 36.7176C32.5094 43.2579 38.2245 52.548 52.8131 47.926ZM50.4145 35.8287C50.0904 36.6968 48.1873 41.3258 44.4692 41.3258C41.8594 41.3258 40.9295 39.5058 40.9295 37.8025C40.9295 36.0317 42.4444 30.6248 50.4138 30.0934L50.4145 35.8287ZM68.677 27.7641V16.521H54.5908L46.6838 10.0859L38.7767 16.521H24.6906V27.7641L15.1641 35.3685V73.1159H76.4302L76.4447 73.1254L76.451 73.1159H78.2035V35.3685L68.677 27.7641ZM46.6838 12.6081L51.4225 16.5204H41.9451L46.6838 12.6081ZM26.6606 18.491H66.7064V44.0642L52.3706 55.5267L46.6838 51.9202L40.9964 55.5267L26.6606 44.0636V18.491ZM24.6906 30.3178V42.4882L17.0805 36.403L24.6906 30.3178ZM17.134 38.9681L39.2369 56.6424L17.134 70.6593V38.9681ZM20.0439 71.1459L46.6838 54.2533L73.3236 71.1459H20.0439ZM76.2335 70.6593L54.1306 56.6431L76.2341 38.9687L76.2335 70.6593ZM68.677 42.4882V30.3178L76.2877 36.403L68.677 42.4882Z",
  fill: "#B8B8B9"
}, null, -1), wl = [
  dl,
  cl
], Kw = /* @__PURE__ */ w({
  __name: "cl-icon-envelope-at",
  props: {
    width: { default: "75px" },
    height: { default: "75px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, wl, 8, il));
  }
}), hl = ["width", "height"], ul = /* @__PURE__ */ o("ellipse", {
  cx: "46.334",
  cy: "46.6492",
  rx: "46.334",
  ry: "46.6492",
  transform: "matrix(1 0 0 -1 0.666016 93.2969)",
  fill: "#F7F7F7"
}, null, -1), pl = /* @__PURE__ */ o("path", {
  d: "M52.8131 47.926L52.0743 46.1004C40.9919 49.9451 34.4793 43.645 34.4793 36.7182C34.4793 29.3716 40.2021 23.8311 47.7908 23.8311C53.9491 23.8311 58.4173 27.8694 58.4173 33.4326C58.4173 38.8559 54.3481 40.3196 52.3844 40.7099V28.095C41.0474 27.7748 38.9602 35.4467 38.9602 37.8019C38.9602 41.0875 41.1741 43.2951 44.4698 43.2951C47.2064 43.2951 49.1467 41.6283 50.4151 39.9225V42.8608C50.4151 42.8608 60.3879 42.8734 60.3879 33.432C60.3879 26.7271 55.0907 21.8604 47.7914 21.8604C38.3512 21.8604 32.51 29.1352 32.51 36.7176C32.5094 43.2579 38.2245 52.548 52.8131 47.926ZM50.4145 35.8287C50.0904 36.6968 48.1873 41.3258 44.4692 41.3258C41.8594 41.3258 40.9295 39.5058 40.9295 37.8025C40.9295 36.0317 42.4444 30.6248 50.4138 30.0934L50.4145 35.8287ZM68.677 27.7641V16.521H54.5908L46.6838 10.0859L38.7767 16.521H24.6906V27.7641L15.1641 35.3685V73.1159H76.4302L76.4447 73.1254L76.451 73.1159H78.2035V35.3685L68.677 27.7641ZM46.6838 12.6081L51.4225 16.5204H41.9451L46.6838 12.6081ZM26.6606 18.491H66.7064V44.0642L52.3706 55.5267L46.6838 51.9202L40.9964 55.5267L26.6606 44.0636V18.491ZM24.6906 30.3178V42.4882L17.0805 36.403L24.6906 30.3178ZM17.134 38.9681L39.2369 56.6424L17.134 70.6593V38.9681ZM20.0439 71.1459L46.6838 54.2533L73.3236 71.1459H20.0439ZM76.2335 70.6593L54.1306 56.6431L76.2341 38.9687L76.2335 70.6593ZM68.677 42.4882V30.3178L76.2877 36.403L68.677 42.4882Z",
  fill: "#B8B8B9"
}, null, -1), _l = [
  ul,
  pl
], Jw = /* @__PURE__ */ w({
  __name: "cl-icon-envelope-letter",
  props: {
    width: { default: "75px" },
    height: { default: "75px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _l, 8, hl));
  }
}), fl = ["width", "height"], gl = /* @__PURE__ */ V('<ellipse cx="46.1858" cy="46.5" rx="46.1858" ry="46.5" transform="matrix(1 0 0 -1 0.813965 93.6484)" fill="#F7F7F7"></ellipse><path d="M70.8522 48.2649C70.5958 48.2649 70.3499 48.3667 70.1687 48.548C69.9874 48.7293 69.8855 48.9752 69.8855 49.2316V74.3668C69.8855 74.8796 69.6818 75.3713 69.3192 75.7339C68.9566 76.0965 68.4648 76.3002 67.952 76.3002H46.6838C46.171 76.3002 45.6793 76.0965 45.3167 75.7339C44.9541 75.3713 44.7504 74.8796 44.7504 74.3668V40.531C44.7504 40.0182 44.9541 39.5264 45.3167 39.1638C45.6793 38.8012 46.171 38.5975 46.6838 38.5975H61.1849V43.4312C61.1849 44.4568 61.5923 45.4404 62.3175 46.1656C63.0427 46.8907 64.0262 47.2982 65.0518 47.2982H70.8522C71.0434 47.2981 71.2303 47.2414 71.3892 47.1352C71.5482 47.0289 71.672 46.878 71.7452 46.7013C71.8183 46.5247 71.8375 46.3304 71.8002 46.1429C71.7629 45.9554 71.6709 45.7831 71.5357 45.6479L62.8351 36.9473C62.745 36.8585 62.6382 36.7886 62.5209 36.7414C62.4036 36.6943 62.278 36.671 62.1516 36.6728V36.6641H46.6838C45.6583 36.6641 44.6747 37.0715 43.9495 37.7967C43.2243 38.5219 42.8169 39.5054 42.8169 40.531V74.3668C42.8169 75.3923 43.2243 76.3759 43.9495 77.1011C44.6747 77.8263 45.6583 78.2337 46.6838 78.2337H67.952C68.9776 78.2337 69.9612 77.8263 70.6864 77.1011C71.4116 76.3759 71.819 75.3923 71.819 74.3668V49.2316C71.819 48.9752 71.7171 48.7293 71.5358 48.548C71.3545 48.3667 71.1086 48.2649 70.8522 48.2649ZM63.1183 39.9645L68.5185 45.3647H65.0518C64.539 45.3647 64.0472 45.161 63.6846 44.7984C63.3221 44.4358 63.1183 43.944 63.1183 43.4312V39.9645Z" fill="#B8B8B9"></path><path d="M63.1193 53.1053H51.5185C51.2621 53.1053 51.0162 53.0035 50.8349 52.8222C50.6536 52.6409 50.5518 52.395 50.5518 52.1386C50.5518 51.8822 50.6536 51.6363 50.8349 51.455C51.0162 51.2737 51.2621 51.1719 51.5185 51.1719H63.1193C63.3757 51.1719 63.6216 51.2737 63.8029 51.455C63.9842 51.6363 64.0861 51.8822 64.0861 52.1386C64.0861 52.395 63.9842 52.6409 63.8029 52.8222C63.6216 53.0035 63.3757 53.1053 63.1193 53.1053Z" fill="#B8B8B9"></path><path d="M63.1193 57.9374H51.5185C51.2621 57.9374 51.0162 57.8355 50.8349 57.6542C50.6536 57.4729 50.5518 57.227 50.5518 56.9706C50.5518 56.7142 50.6536 56.4684 50.8349 56.2871C51.0162 56.1058 51.2621 56.0039 51.5185 56.0039H63.1193C63.3757 56.0039 63.6216 56.1058 63.8029 56.2871C63.9842 56.4684 64.0861 56.7142 64.0861 56.9706C64.0861 57.227 63.9842 57.4729 63.8029 57.6542C63.6216 57.8355 63.3757 57.9374 63.1193 57.9374Z" fill="#B8B8B9"></path><path d="M63.1193 62.7694H51.5185C51.2621 62.7694 51.0162 62.6676 50.8349 62.4863C50.6536 62.305 50.5518 62.0591 50.5518 61.8027C50.5518 61.5463 50.6536 61.3004 50.8349 61.1191C51.0162 60.9378 51.2621 60.8359 51.5185 60.8359H63.1193C63.3757 60.8359 63.6216 60.9378 63.8029 61.1191C63.9842 61.3004 64.0861 61.5463 64.0861 61.8027C64.0861 62.0591 63.9842 62.305 63.8029 62.4863C63.6216 62.6676 63.3757 62.7694 63.1193 62.7694Z" fill="#B8B8B9"></path><path d="M63.1193 67.6014H51.5185C51.2621 67.6014 51.0162 67.4996 50.8349 67.3183C50.6536 67.137 50.5518 66.8911 50.5518 66.6347C50.5518 66.3783 50.6536 66.1324 50.8349 65.9511C51.0162 65.7698 51.2621 65.668 51.5185 65.668H63.1193C63.3757 65.668 63.6216 65.7698 63.8029 65.9511C63.9842 66.1324 64.0861 66.3783 64.0861 66.6347C64.0861 66.8911 63.9842 67.137 63.8029 67.3183C63.6216 67.4996 63.3757 67.6014 63.1193 67.6014Z" fill="#B8B8B9"></path><path d="M61.1841 35.7062C60.9278 35.7062 60.6819 35.6043 60.5006 35.423C60.3193 35.2417 60.2174 34.9958 60.2174 34.7394V26.0388C60.2174 25.526 60.0137 25.0342 59.6511 24.6716C59.2885 24.3091 58.7967 24.1053 58.2839 24.1053H55.3837C55.1273 24.1053 54.8814 24.0035 54.7001 23.8222C54.5188 23.6409 54.417 23.395 54.417 23.1386C54.417 22.8822 54.5188 22.6363 54.7001 22.455C54.8814 22.2737 55.1273 22.1719 55.3837 22.1719H58.2839C59.3095 22.1719 60.2931 22.5793 61.0183 23.3045C61.7435 24.0297 62.1509 25.0132 62.1509 26.0388V34.7394C62.1509 34.9958 62.049 35.2417 61.8677 35.423C61.6864 35.6043 61.4405 35.7062 61.1841 35.7062Z" fill="#B8B8B9"></path><path d="M52.4849 19.2654H45.5949C45.381 18.4349 44.897 17.6991 44.2191 17.1737C43.5412 16.6484 42.7079 16.3633 41.8503 16.3633C40.9927 16.3633 40.1594 16.6484 39.4815 17.1737C38.8036 17.6991 38.3196 18.4349 38.1056 19.2654H31.2167C30.9603 19.2654 30.7144 19.3673 30.5331 19.5486C30.3518 19.7299 30.2499 19.9758 30.2499 20.2322V22.1656H25.4163C24.3907 22.1656 23.4071 22.573 22.6819 23.2982C21.9567 24.0234 21.5493 25.007 21.5493 26.0326V67.6022C21.5493 68.6278 21.9567 69.6114 22.6819 70.3366C23.4071 71.0618 24.3907 71.4692 25.4163 71.4692H40.884C41.1404 71.4692 41.3863 71.3673 41.5676 71.186C41.7489 71.0047 41.8508 70.7588 41.8508 70.5024C41.8508 70.246 41.7489 70.0001 41.5676 69.8188C41.3863 69.6375 41.1404 69.5357 40.884 69.5357H25.4163C24.9035 69.5357 24.4117 69.332 24.0491 68.9694C23.6865 68.6068 23.4828 68.115 23.4828 67.6022V26.0326C23.4828 25.5198 23.6865 25.028 24.0491 24.6654C24.4117 24.3028 24.9035 24.0991 25.4163 24.0991H30.2499V26.0326C30.2499 26.289 30.3518 26.5349 30.5331 26.7162C30.7144 26.8975 30.9603 26.9993 31.2167 26.9993H52.4849C52.7413 26.9993 52.9872 26.8975 53.1685 26.7162C53.3498 26.5349 53.4516 26.289 53.4516 26.0326V20.2322C53.4516 19.9758 53.3498 19.7299 53.1685 19.5486C52.9872 19.3673 52.7413 19.2654 52.4849 19.2654ZM51.5181 25.0658H32.1834V21.1989H38.9506C39.207 21.1989 39.4529 21.097 39.6342 20.9157C39.8154 20.7344 39.9173 20.4886 39.9173 20.2322C39.9173 19.7194 40.121 19.2276 40.4836 18.865C40.8462 18.5024 41.338 18.2987 41.8508 18.2987C42.3636 18.2987 42.8553 18.5024 43.2179 18.865C43.5805 19.2276 43.7842 19.7194 43.7842 20.2322C43.7842 20.4886 43.8861 20.7344 44.0674 20.9157C44.2487 21.097 44.4946 21.1989 44.751 21.1989H51.5181V25.0658Z" fill="#B8B8B9"></path>', 8), bl = [
  gl
], Xw = /* @__PURE__ */ w({
  __name: "cl-icon-paper-board",
  props: {
    width: { default: "75px" },
    height: { default: "75px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, bl, 8, fl));
  }
}), vl = ["width", "height"], ml = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), yl = /* @__PURE__ */ o("path", { d: "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" }, null, -1), xl = /* @__PURE__ */ o("path", { d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" }, null, -1), $l = [
  ml,
  yl,
  xl
], Yw = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-copy",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-copy",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, $l, 8, vl));
  }
}), kl = ["width", "height"], Cl = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Ml = /* @__PURE__ */ o("path", {
  d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
  "stroke-width": "0",
  fill: "currentColor"
}, null, -1), Bl = [
  Cl,
  Ml
], t1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-info-filled",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-info-circle-filled",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Bl, 8, kl));
  }
}), Il = ["width", "height"], zl = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path><path d="M16 3l0 4"></path><path d="M8 3l0 4"></path><path d="M4 11l16 0"></path><path d="M8 15h2v2h-2z"></path>', 6), Tl = [
  zl
], e1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-calendar-event",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-calendar-event",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Tl, 8, Il));
  }
}), Hl = ["width", "height"], Sl = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), jl = /* @__PURE__ */ o("path", { d: "M12 9v4" }, null, -1), Ll = /* @__PURE__ */ o("path", { d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" }, null, -1), Vl = /* @__PURE__ */ o("path", { d: "M12 16h.01" }, null, -1), Pl = [
  Sl,
  jl,
  Ll,
  Vl
], o1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-alert-triangle",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-alert-triangle",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Pl, 8, Hl));
  }
}), Al = ["width", "height"], Ol = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Dl = /* @__PURE__ */ o("path", {
  d: "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
  "stroke-width": "0",
  fill: "#00BAA0"
}, null, -1), Nl = [
  Ol,
  Dl
], Fl = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-circle-check-filled",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-circle-check-filled",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Nl, 8, Al));
  }
}), El = ["width", "height"], Zl = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path><path d="M4 6l8 0"></path><path d="M16 6l4 0"></path><path d="M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path><path d="M4 12l2 0"></path><path d="M10 12l10 0"></path><path d="M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path><path d="M4 18l11 0"></path><path d="M19 18l1 0"></path>', 10), Rl = [
  Zl
], s1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-adjustments-horizontal",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-adjustments-horizontal",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Rl, 8, El));
  }
}), Ul = ["width", "height"], Wl = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Gl = /* @__PURE__ */ o("path", { d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6" }, null, -1), Ql = /* @__PURE__ */ o("path", { d: "M3 7l9 6l9 -6" }, null, -1), ql = /* @__PURE__ */ o("path", { d: "M15 19l2 2l4 -4" }, null, -1), Kl = [
  Wl,
  Gl,
  Ql,
  ql
], n1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-mail-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-mail-check",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Kl, 8, Ul));
  }
}), Jl = ["width", "height"], Xl = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Yl = /* @__PURE__ */ o("path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }, null, -1), tr = /* @__PURE__ */ o("path", { d: "M9 9l6 6" }, null, -1), er = [
  Xl,
  Yl,
  tr
], a1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-forbid",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-forbid",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, er, 8, Jl));
  }
}), or = ["width", "height"], sr = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M16 19h6"></path><path d="M19 16v6"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h4"></path>', 5), nr = [
  sr
], l1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-user-plus",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-user-plus",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, nr, 8, or));
  }
}), ar = ["width", "height"], lr = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), rr = /* @__PURE__ */ o("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }, null, -1), ir = /* @__PURE__ */ o("path", { d: "M21 21l-6 -6" }, null, -1), dr = [
  lr,
  rr,
  ir
], Ht = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-search",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-search",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, dr, 8, ar));
  }
}), cr = ["width", "height"], wr = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), hr = /* @__PURE__ */ o("path", { d: "M16 9v6a5 5 0 0 1 -10 0v-4l3 3" }, null, -1), ur = /* @__PURE__ */ o("path", { d: "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }, null, -1), pr = /* @__PURE__ */ o("path", { d: "M16 5v-2" }, null, -1), _r = [
  wr,
  hr,
  ur,
  pr
], r1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-fish-hook",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-fish-hook",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      width: t.width,
      height: t.height,
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, _r, 8, cr));
  }
}), fr = ["width", "height"], gr = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), br = /* @__PURE__ */ o("path", { d: "M22 9l-10 -4l-10 4l10 4l10 -4v6" }, null, -1), vr = /* @__PURE__ */ o("path", { d: "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4" }, null, -1), mr = [
  gr,
  br,
  vr
], i1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-school",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-school",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, mr, 8, fr));
  }
}), yr = ["width", "height"], xr = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), $r = /* @__PURE__ */ o("path", { d: "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" }, null, -1), kr = /* @__PURE__ */ o("path", { d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" }, null, -1), Cr = /* @__PURE__ */ o("path", { d: "M10 12l4 0" }, null, -1), Mr = [
  xr,
  $r,
  kr,
  Cr
], d1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-archive",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-archive",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Mr, 8, yr));
  }
}), Br = ["width", "height"], Ir = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), zr = /* @__PURE__ */ o("path", { d: "M5 12l5 5l10 -10" }, null, -1), Tr = [
  Ir,
  zr
], c1 = /* @__PURE__ */ w({
  __name: "cl-icon-table-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-check",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, Tr, 8, Br));
  }
}), Hr = ["width", "height"], Sr = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M20.946 12.99a9 9 0 1 0 -9.46 7.995"></path><path d="M3.6 9h16.8"></path><path d="M3.6 15h13.9"></path><path d="M11.5 3a17 17 0 0 0 0 18"></path><path d="M12.5 3a16.997 16.997 0 0 1 2.311 12.001"></path><path d="M15 19l2 2l4 -4"></path>', 7), jr = [
  Sr
], w1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-world-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icons-tabler-outline icon-tabler-world-check"
    }, jr, 8, Hr));
  }
}), Lr = ["width", "height"], Vr = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), Pr = /* @__PURE__ */ o("path", { d: "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" }, null, -1), Ar = /* @__PURE__ */ o("path", { d: "M11 13l9 -9" }, null, -1), Or = /* @__PURE__ */ o("path", { d: "M15 4h5v5" }, null, -1), Dr = [
  Vr,
  Pr,
  Ar,
  Or
], h1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-external-link",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icon-tabler-external-link"
    }, Dr, 8, Lr));
  }
}), Nr = ["width", "height"], Fr = /* @__PURE__ */ V('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"></path><path d="M17 18h2"></path><path d="M20 15h-3v6"></path><path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"></path>', 7), Er = [
  Fr
], u1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-file-type-pdf",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icons-tabler-outline icon-tabler-file-type-pdf"
    }, Er, 8, Nr));
  }
}), Zr = ["width", "height"], Rr = /* @__PURE__ */ o("path", {
  d: "M16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 19.4696 18.2107 18.9609 18.5858 18.5858C18.9609 18.2107 19.4696 18 20 18C19.4696 18 18.9609 17.7893 18.5858 17.4142C18.2107 17.0391 18 16.5304 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18ZM16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6C19.4696 6 18.9609 5.78929 18.5858 5.41421C18.2107 5.03914 18 4.53043 18 4C18 4.53043 17.7893 5.03914 17.4142 5.41421C17.0391 5.78929 16.5304 6 16 6ZM9 18C9 16.4087 9.63214 14.8826 10.7574 13.7574C11.8826 12.6321 13.4087 12 15 12C13.4087 12 11.8826 11.3679 10.7574 10.2426C9.63214 9.11742 9 7.5913 9 6C9 7.5913 8.36786 9.11742 7.24264 10.2426C6.11742 11.3679 4.5913 12 3 12C4.5913 12 6.11742 12.6321 7.24264 13.7574C8.36786 14.8826 9 16.4087 9 18Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ur = [
  Rr
], p1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-sparkles",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Ur, 8, Zr));
  }
}), Wr = ["width", "height"], Gr = /* @__PURE__ */ o("path", {
  d: "M16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 19.4696 18.2107 18.9609 18.5858 18.5858C18.9609 18.2107 19.4696 18 20 18C19.4696 18 18.9609 17.7893 18.5858 17.4142C18.2107 17.0391 18 16.5304 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18ZM16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6C19.4696 6 18.9609 5.78929 18.5858 5.41421C18.2107 5.03914 18 4.53043 18 4C18 4.53043 17.7893 5.03914 17.4142 5.41421C17.0391 5.78929 16.5304 6 16 6ZM9 18C9 16.4087 9.63214 14.8826 10.7574 13.7574C11.8826 12.6321 13.4087 12 15 12C13.4087 12 11.8826 11.3679 10.7574 10.2426C9.63214 9.11742 9 7.5913 9 6C9 7.5913 8.36786 9.11742 7.24264 10.2426C6.11742 11.3679 4.5913 12 3 12C4.5913 12 6.11742 12.6321 7.24264 13.7574C8.36786 14.8826 9 16.4087 9 18Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qr = [
  Gr
], _1 = /* @__PURE__ */ w({
  __name: "cl-icon-tabler-sparkles-horizontal",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(s) {
    return (t, e) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: "tw-scale-x-[-1]"
    }, Qr, 8, Wr));
  }
}), qr = ["href"], Kr = ["data-test-id"], Jr = ["href"], Xr = ["data-test-id"], Yr = { class: "tw-flex tw-w-full tw-justify-between" }, f1 = /* @__PURE__ */ w({
  __name: "cl-sidebar-nav-item-child",
  props: {
    label: {},
    isClosed: { type: Boolean },
    navigate: {},
    href: {},
    isActive: { type: Boolean, default: !1 },
    dataTestId: { default: "child-subnav" },
    disabled: { type: Boolean, default: !1 },
    needsToggle: { type: Boolean, default: !1 },
    hasDescendants: { type: Boolean, default: !1 },
    hasActiveDescendants: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = M(!1), n = M(null);
    W(n, () => {
      e.value && (e.value = !1);
    });
    const d = t, r = () => {
      e.value || (e.value = !0), d("on-click", e.value);
    };
    return (i, c) => (a(), l(H, null, [
      i.isClosed ? (a(), l("div", {
        key: 0,
        ref_key: "toggleChild",
        ref: n,
        onClick: c[1] || (c[1] = (h) => r())
      }, [
        o("a", {
          href: i.href,
          class: p({
            "tw-pointer-events-none": i.disabled
          }),
          onClick: c[0] || (c[0] = //@ts-ignore
          (...h) => i.navigate && i.navigate(...h))
        }, [
          o("li", {
            class: p(["tw-flex tw-w-60 tw-cursor-pointer tw-justify-between tw-p-4 hover:tw-bg-aside-400", [
              i.isActive ? "tw-bg-aside-400 tw-px-4 tw-font-bold tw-transition-all" : "tw-bg-aside-600",
              i.disabled && "tw-text-dorian-gray-200 dark:tw-text-dorian-gray-300",
              i.hasDescendants && "tw-pl-8",
              i.hasActiveDescendants && "tw-bg-aside-600 tw-shadow-none"
            ]]),
            "data-test-id": `${i.dataTestId}-closed`
          }, [
            R(y(i.label) + " ", 1),
            i.needsToggle ? (a(), A(u(ot), {
              key: 0,
              class: p(["tw-transition-transform", e.value ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])) : x("", !0)
          ], 10, Kr)
        ], 10, qr)
      ], 512)) : x("", !0),
      i.isClosed ? x("", !0) : (a(), l("div", {
        key: 1,
        ref_key: "toggleChild",
        ref: n,
        onClick: c[3] || (c[3] = (h) => r())
      }, [
        o("a", {
          href: i.href,
          class: p({
            "tw-pointer-events-none": i.disabled
          }),
          onClick: c[2] || (c[2] = //@ts-ignore
          (...h) => i.navigate && i.navigate(...h))
        }, [
          o("li", {
            class: p(["tw-flex tw-w-full tw-cursor-pointer tw-justify-between tw-p-4 hover:tw-bg-aside-400", [
              i.isActive ? "tw-bg-aside-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-dorian-gray-500" : "",
              i.disabled && "tw-text-dorian-gray-200 dark:tw-text-dorian-gray-300",
              i.hasActiveDescendants && "tw-shadow-none"
            ]]),
            "data-test-id": `${i.dataTestId}-open`
          }, [
            o("div", Yr, [
              o("span", {
                class: p(i.hasDescendants ? "tw-pl-[75px] " : "tw-pl-10")
              }, y(i.label), 3),
              o("span", null, [
                f(i.$slots, "pill")
              ])
            ]),
            i.needsToggle ? (a(), A(u(ot), {
              key: 0,
              class: p(["tw-transition-transform", e.value ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])) : x("", !0)
          ], 10, Xr)
        ], 10, Jr)
      ], 512))
    ], 64));
  }
}), ti = {};
function ei(s, t) {
  return a(), l("nav", null, [
    o("ul", null, [
      f(s.$slots, "default")
    ])
  ]);
}
const g1 = /* @__PURE__ */ j(ti, [["render", ei]]), oi = ["data-test-id"], si = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Dropdown", -1), ni = { class: "tw-relative" }, ai = { class: "tw-relative" }, li = { class: "tw-max-h-[50dvh] tw-w-full tw-overflow-y-auto" }, b1 = /* @__PURE__ */ w({
  __name: "cl-sidebar-dropdown",
  props: {
    testId: { default: "cl-dropdown-toggle-btn" },
    isClosed: { type: Boolean }
  },
  emits: ["on-dropdown"],
  setup(s, { emit: t }) {
    const e = s, n = M(!1), d = M(null);
    W(d, () => {
      n.value && (n.value = !1);
    });
    const r = C(() => [
      n.value ? "tw-opacity-100" : "tw-opacity-0",
      e.isClosed ? "tw-absolute tw-left-[100%] tw-top-0" : ""
    ]), i = t, c = C(() => e.isClosed ? n.value ? "tw-rotate-90" : "tw-rotate-[270deg]" : n.value ? "tw-rotate-180" : "tw-rotate-0"), h = () => {
      n.value = !n.value, n.value && i("on-dropdown");
    };
    return (b, m) => (a(), l("div", {
      ref_key: "target",
      ref: d,
      class: p(["tw-relative", [b.isClosed ? "tw-px-0" : "tw-mx-2"]])
    }, [
      o("button", {
        class: p(["tw-flex tw-min-h-[52px] tw-w-full tw-items-center tw-justify-between tw-bg-aside-400 tw-py-2 tw-text-base tw-font-bold tw-text-white tw-outline-none tw-outline-4 tw-outline-offset-0 tw-transition-all hover:tw-bg-aside-300 dark:tw-text-dorian-gray-500", [
          b.isClosed ? "tw-px-2" : "tw-px-6",
          n.value && !b.isClosed ? "tw-rounded-b-0 tw-rounded-t" : "",
          !n.value && !b.isClosed ? "tw-rounded-b tw-rounded-t" : ""
        ]]),
        type: "button",
        "data-test-id": e.testId,
        onClick: h
      }, [
        si,
        f(b.$slots, "title"),
        I(u(ot), {
          class: p(["tw-min-w-[16px] tw-transition-transform", c.value])
        }, null, 8, ["class"])
      ], 10, oi),
      n.value ? (a(), l("div", {
        key: 0,
        class: p(["tw-outline-t-0 tw-absolute tw-right-0 tw-z-10 tw-flex tw-w-full tw-min-w-[240px] tw-flex-col tw-rounded-b-md tw-border tw-border-aside-300/80 tw-bg-aside-400 tw-shadow tw-transition-opacity", r.value]),
        onClick: m[0] || (m[0] = ($) => n.value = !1)
      }, [
        o("div", ni, [
          f(b.$slots, "search")
        ]),
        o("div", ai, [
          o("ul", li, [
            f(b.$slots, "menu")
          ])
        ])
      ], 2)) : x("", !0)
    ], 2));
  }
}), ri = { class: "tw-relative" }, ii = ["for"], di = ["id", "name", "placeholder", "data-test-id"], ci = { class: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3" }, v1 = /* @__PURE__ */ w({
  __name: "cl-sidebar-dropdown-search",
  props: {
    id: { default: "sidebar-dropdown-search" },
    name: { default: "sidebar-dropdown-search" },
    placeholder: { default: "Search" },
    dataTestId: { default: "sidebar-dropdown-search" }
  },
  emits: ["search"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = (r) => {
      n("search", r.target.value);
    };
    return (r, i) => (a(), l("div", ri, [
      o("label", {
        for: e.id,
        class: "tw-sr-only"
      }, "Search", 8, ii),
      o("input", {
        id: e.id,
        type: "search",
        class: "tw-h-10 tw-w-full tw-border-none tw-bg-white tw-py-2 tw-pl-9 tw-pr-4 tw-text-base tw-text-dorian-gray-500 tw-shadow-none tw-outline-none focus:tw-ring-0 dark:tw-border dark:tw-border-solid dark:tw-border-dorian-gray-100",
        name: e.name,
        placeholder: e.placeholder,
        "data-test-id": e.dataTestId,
        onClick: i[0] || (i[0] = $t(() => {
        }, ["stop"])),
        onInput: i[1] || (i[1] = (c) => d(c))
      }, null, 40, di),
      o("div", ci, [
        I(u(Ht), {
          width: "20px",
          height: "20px",
          class: "tw-text-dorian-gray-200"
        })
      ])
    ]));
  }
}), m1 = /* @__PURE__ */ w({
  __name: "cl-sidebar-dropdown-menu-item",
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = t, n = () => {
      e("on-click");
    };
    return (d, r) => (a(), l("li", {
      class: "tw-cursor-pointer tw-px-6 tw-py-4 hover:tw-bg-aside-300",
      onClick: n
    }, [
      f(d.$slots, "default")
    ]));
  }
}), ut = /* @__PURE__ */ w({
  __name: "cl-heading",
  props: {
    size: { default: "h1" }
  },
  setup(s) {
    const t = s, e = {
      h1: "tw-text-5xl tw-font-medium",
      h2: "tw-text-4xl tw-font-medium",
      h3: "tw-text-3xl tw-font-medium",
      h4: "tw-text-2xl tw-font-semibold",
      h5: "tw-text-xl tw-font-semibold",
      h6: "tw-text-lg tw-font-semibold"
    }, n = C(() => [
      "tw-text-dorian-gray-500",
      "tw-mb-3",
      e[t.size]
    ]);
    return (d, r) => (a(), A(dt(t.size), {
      class: p(n.value)
    }, {
      default: F(() => [
        f(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), wi = ["id"], St = /* @__PURE__ */ w({
  __name: "cl-tooltip",
  props: {
    id: {},
    text: {},
    position: { default: "top" }
  },
  setup(s) {
    const t = {
      top: "tw--top-3 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-transform",
      bottom: "tw--bottom-8 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-transform"
    }, e = s, n = C(() => [t[e.position]]), d = M(!1);
    return (r, i) => (a(), l("div", {
      class: "tw-relative tw-inline-block",
      onMouseover: i[0] || (i[0] = (c) => d.value = !0),
      onMouseleave: i[1] || (i[1] = (c) => d.value = !1)
    }, [
      f(r.$slots, "default"),
      d.value ? (a(), l("span", {
        key: 0,
        id: e.id,
        class: p(["tw-absolute tw-z-10 tw-h-fit tw-min-w-max tw-rounded tw-border tw-border-solid tw-border-dorian-gray-200 tw-bg-white tw-px-2 tw-shadow", n.value]),
        role: "tooltip"
      }, y(r.text), 11, wi)) : x("", !0)
    ], 32));
  }
}), hi = { class: "tw-p-2" }, ui = { class: "tw-w-full" }, pi = { class: "tw-grid tw-grid-cols-12 tw-gap-1" }, _i = { class: "tw-col-span-12 md:tw-col-span-6" }, fi = {
  key: 0,
  class: "tw-w-full"
}, gi = /* @__PURE__ */ o("label", {
  for: "cl-data-table-search",
  class: "tw-sr-only"
}, "Search", -1), bi = { class: "tw-relative md:tw-max-w-xs" }, vi = ["data-test-id", "placeholder"], mi = { class: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3" }, yi = { class: "tw-col-span-12 md:tw-col-span-6" }, xi = { class: "tw-flex tw-w-full tw-items-center tw-justify-end" }, $i = {
  key: 0,
  class: "tw-flex tw-items-center"
}, ki = {
  key: 0,
  class: "tw-relative"
}, Ci = { class: "tw-whitespace-nowrap tw-pr-2 tw-text-sm tw-text-dorian-gray-500" }, Mi = {
  key: 1,
  class: "tw-relative"
}, Bi = ["data-test-id"], Ii = {
  key: 2,
  class: "tw-relative"
}, zi = ["data-test-id"], Ti = {
  key: 3,
  class: "tw-relative"
}, Hi = ["data-test-id"], Si = {
  key: 0,
  id: "set-rows-wrapper",
  class: "tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-p-2 tw-shadow-md tw-transition-opacity"
}, ji = ["for"], Li = ["id", "value", "disabled"], Vi = { class: "tw-mb-6tw-p-2" }, Pi = { class: "tw-w-full tw-rounded tw-text-left tw-text-base tw-shadow dark:tw-border dark:tw-border-solid dark:tw-border-dorian-gray-100/80 dark:tw-shadow-none" }, Ai = { class: "tw-bg-white" }, Oi = {
  key: 0,
  scope: "col",
  class: "tw-pl-4"
}, Di = { class: "tw-flex tw-items-center" }, Ni = ["disabled"], Fi = /* @__PURE__ */ o("label", {
  for: "table-header-select-all",
  class: "tw-sr-only"
}, "checkbox", -1), Ei = ["onClick"], Zi = { class: "tw-whitespace-nowrap tw-font-bold" }, Ri = { key: 0 }, Ui = { key: 0 }, Wi = {
  key: 0,
  class: "tw-w-4 tw-px-4"
}, Gi = /* @__PURE__ */ o("div", { class: "tw-w-30 tw-h-5 tw-animate-pulse tw-bg-light" }, null, -1), Qi = [
  Gi
], qi = /* @__PURE__ */ o("div", { class: "tw-w-30 tw-h-5 tw-animate-pulse tw-bg-light" }, null, -1), Ki = [
  qi
], Ji = { key: 1 }, Xi = {
  key: 0,
  class: "tw-border-b tw-border-dorian-gray-100/80 tw-bg-light"
}, Yi = /* @__PURE__ */ o("td", {
  colspan: "100%",
  class: "tw-pl-2 tw-text-center"
}, " No data available ", -1), td = [
  Yi
], ed = ["onClick"], od = { class: "tw-flex tw-items-center" }, sd = ["id", "data-test-id", "value", "disabled"], nd = ["for"], ad = { class: "tw-mb-6 tw-p-2" }, ld = { class: "tw-w-full" }, rd = { class: "tw-grid tw-grid-cols-12 tw-gap-1" }, id = { class: "tw-col-span-12 md:tw-col-span-6" }, dd = { class: "tw-relative" }, cd = { class: "tw-mr-4 tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start" }, wd = /* @__PURE__ */ o("label", { class: "tw-mr-4 tw-whitespace-nowrap tw-text-sm tw-text-dorian-gray-500" }, " Rows per page: ", -1), hd = ["value", "selected"], ud = {
  key: 0,
  class: "tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start"
}, pd = { class: "tw-text-sm tw-text-dorian-gray-500" }, _d = { class: "tw-col-span-12 md:tw-col-span-6" }, fd = { class: "tw-relative tw-flex tw-justify-end" }, gd = ["disabled"], bd = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Previous", -1), vd = ["disabled"], md = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Next", -1), Y = 1, y1 = /* @__PURE__ */ w({
  __name: "cl-data-table",
  props: {
    headers: {},
    items: {},
    total: {},
    itemsPerPage: { default: () => [10, 25, 50] },
    testId: { default: "default-test-id" },
    fetching: { type: Boolean, default: !1 },
    withSelect: { type: Boolean, default: !1 },
    withSelectAll: { type: Boolean, default: !0 },
    withSearch: { type: Boolean, default: !1 },
    withDelete: { type: Boolean, default: !1 },
    withRelease: { type: Boolean, default: !1 },
    withAllow: { type: Boolean, default: !1 },
    withServerSidePagination: { type: Boolean, default: !1 },
    deletePlaceholder: { default: "Delete" },
    releasePlaceholder: { default: "Release" },
    allowPlaceholder: { default: "Allow" },
    searchPlaceholder: { default: "Search" },
    searchBy: { default: "id" },
    withSetColumns: { type: Boolean, default: !1 },
    zebra: { type: Boolean, default: !0 },
    defaultItemsOnPage: { default: 10 },
    defaultSortBy: { default: "" },
    defaultSortDesc: { default: "desc" },
    withRowClick: { type: Boolean, default: !1 },
    px: { default: 6 }
  },
  emits: ["onDeleteItems", "onReleaseItems", "onAllowItems", "search", "sortItems", "changePage", "changeItemsOnPage", "changeSelectedColumns", "onSelectItems", "onRowClick"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = rt(), r = M(!1), i = M(""), c = M(e.defaultItemsOnPage || e.itemsPerPage[0]), h = M(e.defaultSortBy), b = M(e.defaultSortDesc), m = M(!1), $ = M([]), v = M(Y), B = M(null), T = M(null), st = () => {
      B.value && (B.value.scrollTop = B.value.scrollHeight);
    }, O = M(
      e.headers.map((g) => {
        const k = { ...g };
        return "enabled" in k || (k.enabled = !0), k;
      })
    ), G = M(
      O.value.filter((g) => g.enabled).map((g) => g.key)
    ), E = M(
      O.value.filter((g) => g.enabled).map((g) => g.key)
    ), nt = C(() => {
      const g = v.value * c.value;
      return { start: g - c.value, end: g };
    }), it = C(() => {
      if (e.withServerSidePagination)
        return e.items;
      const g = [...e.items];
      return h.value && g.sort((k, _) => {
        const z = k[h.value], N = _[h.value];
        if (typeof z == "number" && typeof N == "number")
          return b.value === "asc" ? z - N : N - z;
        if (typeof z == "string" && typeof N == "string") {
          const q = Date.parse(z), X = Date.parse(N);
          return isNaN(q) ? b.value === "asc" ? z.localeCompare(N) : N.localeCompare(z) : b.value === "asc" ? q - X : X - q;
        }
        return b.value === "asc" ? z - N : N - z;
      }), e.withSearch && i.value ? g.filter(
        (k) => k[e.searchBy].toLowerCase().includes(i.value.toLowerCase())
      ) : g;
    }), J = C(() => e.withServerSidePagination ? e.items : it.value.slice(
      nt.value.start,
      nt.value.end
    )), jt = C(() => i.value.length !== 0 && !e.withServerSidePagination ? Math.ceil(it.value.length / c.value) : Math.ceil(e.total / c.value)), pt = C(() => $.value.length > 0), Lt = (g) => g != null && g.sticky ? "tw-sticky tw-right-0 tw-bg-white" : "", Vt = (g) => {
      let k = g != null && g.sticky ? "tw-border-l tw-border-dorian-gray-100/80" : "";
      return k += ` tw-px-${e.px}`, k;
    }, Pt = (g) => {
      const k = e.headers.find((z) => z.key === g);
      return k != null && k.sticky ? "tw-sticky tw-right-0 tw-bg-[inherit]" : "";
    }, At = (g) => {
      const k = e.headers.find((z) => z.key === g);
      let _ = k != null && k.sticky ? "tw-border-l tw-border-dorian-gray-100/80" : "";
      return _ += ` tw-px-${e.px}`, _;
    }, Ot = (g) => {
      const k = g.target.checked;
      $.value = k ? [...J.value.filter((_) => {
        var z;
        return !((z = _.metadata) != null && z.inherited);
      })] : [];
    }, Dt = () => {
      e.withSelectAll || ($.value = $.value.slice(-1)), m.value && (m.value = !1);
    }, Nt = () => {
      Q(), v.value = v.value + 1, n("changePage", v.value);
    }, Ft = () => {
      Q(), v.value = v.value - 1, n("changePage", v.value);
    }, Et = () => {
      v.value = Y, n("changeItemsOnPage", c.value);
    }, Q = () => {
      m.value = !1, $.value = [];
    }, Zt = C(() => {
      const g = [];
      for (let k = 0; k < 10; k++) {
        const _ = {};
        e.headers.forEach((z) => {
          _[z.key] = "";
        }), g.push(_);
      }
      return g;
    }), Rt = (g) => {
      g.sortable && (h.value !== g.key && (h.value = g.key), b.value === "asc" ? b.value = "desc" : b.value = "asc", n("sortItems", h.value, b.value));
    }, Ut = () => {
      n("onDeleteItems", $.value), Q();
    }, Wt = () => {
      n("onReleaseItems", $.value), Q();
    }, Gt = () => {
      n("onAllowItems", $.value), Q();
    }, Qt = (g) => {
      v.value = Y, n("search", g.target.value);
    }, qt = () => {
      r.value = !r.value;
    };
    W(T, () => {
      r.value = !1;
    });
    const at = M(null), Kt = (g) => {
      at.value = g.id, n("onRowClick", g);
    };
    return S(
      () => e.headers,
      () => {
        O.value = e.headers.map((g) => {
          const k = { ...g };
          return "enabled" in k || (k.enabled = !0), k;
        }), E.value = O.value.filter((g) => g.enabled).map((g) => g.key);
      },
      { deep: !0 }
    ), S(
      () => E.value,
      () => {
        O.value = O.value.map((g) => ({
          ...g,
          enabled: E.value.includes(g.key)
        })), G.value = O.value.filter((g) => g.enabled).map((g) => g.key), n("changeSelectedColumns", E.value);
      }
    ), S(
      () => e.defaultItemsOnPage,
      () => {
        c.value = e.defaultItemsOnPage || e.itemsPerPage[0];
      }
    ), S(
      () => e.defaultSortBy,
      () => {
        h.value = e.defaultSortBy;
      }
    ), S(
      () => e.defaultSortDesc,
      () => {
        b.value = e.defaultSortDesc;
      }
    ), S(
      () => e.items,
      () => {
        Q();
      }
    ), S(
      () => $.value,
      () => {
        n("onSelectItems", $.value);
      }
    ), S(
      () => e.total,
      () => v.value = Y
    ), (g, k) => (a(), l(H, null, [
      o("section", hi, [
        o("div", ui, [
          o("div", pi, [
            o("div", _i, [
              e.withSearch ? (a(), l("div", fi, [
                gi,
                o("div", bi, [
                  D(o("input", {
                    id: "cl-data-table-search",
                    "onUpdate:modelValue": k[0] || (k[0] = (_) => i.value = _),
                    class: p(["tw-block tw-w-full tw-rounded tw-border tw-border-solid tw-border-dorian-gray-100/80 tw-bg-white tw-py-2 tw-pl-9 tw-pr-2 tw-text-base tw-text-dorian-gray-500 tw-outline-none tw-transition-all focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", [pt.value ? "tw-w-1/2" : "tw-w-full"]]),
                    type: "search",
                    "data-test-id": `${e.testId}-search`,
                    placeholder: e.searchPlaceholder,
                    onInput: k[1] || (k[1] = (_) => Qt(_))
                  }, null, 42, vi), [
                    [wt, i.value]
                  ]),
                  o("div", mi, [
                    I(u(Ht), {
                      width: "20px",
                      height: "20px",
                      class: "tw-text-dorian-gray-200"
                    })
                  ])
                ])
              ])) : x("", !0),
              f(g.$slots, "search")
            ]),
            o("div", yi, [
              o("div", xi, [
                pt.value ? (a(), l("div", $i, [
                  $.value ? (a(), l("div", ki, [
                    o("span", Ci, y($.value.length) + " Selected", 1)
                  ])) : x("", !0),
                  e.withDelete ? (a(), l("div", Mi, [
                    o("button", {
                      class: "tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-danger-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-danger-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-danger-600 focus:tw-outline-4 focus:tw-outline-danger-500/10 active:tw-border-danger-800 active:tw-text-danger-800",
                      type: "button",
                      "data-test-id": `${e.testId}-delete`,
                      onClick: Ut
                    }, y(e.deletePlaceholder), 9, Bi)
                  ])) : x("", !0),
                  e.withRelease ? (a(), l("div", Ii, [
                    o("button", {
                      class: "tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-secondary-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-secondary-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-secondary-600 focus:tw-outline-4 focus:tw-outline-secondary-500/10 active:tw-border-secondary-800 active:tw-text-secondary-800",
                      type: "button",
                      "data-test-id": `${e.testId}-release`,
                      onClick: Wt
                    }, y(e.releasePlaceholder), 9, zi)
                  ])) : x("", !0),
                  e.withAllow ? (a(), l("div", Ti, [
                    o("button", {
                      class: "tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-secondary-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-secondary-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-secondary-600 focus:tw-outline-4 focus:tw-outline-secondary-500/10 active:tw-border-secondary-800 active:tw-text-secondary-800",
                      type: "button",
                      "data-test-id": `${e.testId}-allow`,
                      onClick: Gt
                    }, y(e.allowPlaceholder), 9, Hi)
                  ])) : x("", !0)
                ])) : x("", !0),
                u(d).actions ? f(g.$slots, "actions", {
                  key: 1,
                  selectedItems: $.value
                }) : x("", !0),
                g.withSetColumns ? (a(), l("div", {
                  key: 2,
                  ref_key: "columnSetTooltip",
                  ref: T,
                  class: "column-set-tooltip-wrapper"
                }, [
                  o("button", {
                    class: "tw-group tw-mx-4 tw-flex tw-h-9 tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-dorian-gray-100 tw-pl-4",
                    onClick: qt
                  }, [
                    I(u(Rn), {
                      width: "24",
                      height: "24",
                      class: p([
                        "tw-transition-colors group-hover:tw-stroke-secondary-500",
                        r.value ? "tw-stroke-secondary-500" : "tw-stroke-dorian-gray-500"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  r.value ? (a(), l("div", Si, [
                    (a(!0), l(H, null, L(O.value, (_) => (a(), l("div", {
                      key: _.key,
                      class: "tw-my-1"
                    }, [
                      o("label", {
                        for: _.key,
                        class: "tw-ml-2 tw-flex tw-items-center"
                      }, [
                        D(o("input", {
                          id: _.key,
                          "onUpdate:modelValue": k[2] || (k[2] = (z) => E.value = z),
                          value: _.key,
                          type: "checkbox",
                          class: "tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400",
                          disabled: E.value.length <= 1 && _.enabled
                        }, null, 8, Li), [
                          [K, E.value]
                        ]),
                        o("span", {
                          class: p([
                            "text-dorian-gray-300 tw-ml-3 tw-text-base",
                            E.value.length <= 1 && _.enabled && "tw-text-dorian-gray-200"
                          ])
                        }, y(_.label), 3)
                      ], 8, ji)
                    ]))), 128))
                  ])) : x("", !0)
                ], 512)) : x("", !0)
              ])
            ])
          ])
        ])
      ]),
      o("section", Vi, [
        o("div", {
          ref_key: "scrollContainer",
          ref: B,
          class: "tw-overflow-x-auto tw-shadow"
        }, [
          o("table", Pi, [
            o("thead", Ai, [
              o("tr", null, [
                e.withSelect ? (a(), l("th", Oi, [
                  o("div", Di, [
                    D(o("input", {
                      id: "table-header-select-all",
                      "onUpdate:modelValue": k[3] || (k[3] = (_) => m.value = _),
                      disabled: !e.withSelectAll,
                      type: "checkbox",
                      class: p({
                        "tw-h-4 tw-w-4 tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-100 tw-bg-dorian-gray-100 hover:tw-cursor-not-allowed dark:tw-border-dorian-gray-50": !e.withSelectAll,
                        "tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400": e.withSelectAll
                      }),
                      onChange: Ot
                    }, null, 42, Ni), [
                      [K, m.value]
                    ]),
                    Fi
                  ])
                ])) : x("", !0),
                (a(!0), l(H, null, L(O.value, (_) => (a(), l(H, {
                  key: _.label
                }, [
                  _.enabled ? (a(), l("th", {
                    key: 0,
                    scope: "col",
                    class: p(Lt(_))
                  }, [
                    o("div", {
                      class: p(["tw-inline-flex tw-items-center tw-py-1", Vt(_)])
                    }, [
                      o("div", {
                        class: p([
                          "tw-peer",
                          _.sortable ? "hover:tw-cursor-pointer" : "tw-cursor-auto"
                        ]),
                        onClick: (z) => Rt(_)
                      }, [
                        f(g.$slots, `header.cell.${String(
                          _.label
                        ).toLocaleLowerCase()}`, {
                          text: _.label
                        }, () => [
                          o("span", Zi, y(_.label), 1)
                        ])
                      ], 10, Ei),
                      _.tooltip ? (a(), A(u(St), {
                        key: 0,
                        id: _.key,
                        text: _.tooltip,
                        class: "tw-ml-1 hover:tw-cursor-pointer"
                      }, {
                        default: F(() => [
                          _.tooltip ? (a(), l("span", Ri, [
                            I(u(zt), {
                              width: 16,
                              height: 16
                            })
                          ])) : x("", !0)
                        ]),
                        _: 2
                      }, 1032, ["id", "text"])) : x("", !0),
                      o("span", {
                        class: p(
                          _.sortable && h.value === _.key ? "peer-hover:tw-visible" : "tw-invisible"
                        )
                      }, [
                        b.value === "desc" ? (a(), A(u(ia), {
                          key: 0,
                          width: "16",
                          height: "16"
                        })) : (a(), A(u(_a), {
                          key: 1,
                          width: "16",
                          height: "16"
                        }))
                      ], 2)
                    ], 2)
                  ], 2)) : x("", !0)
                ], 64))), 128))
              ])
            ]),
            e.fetching ? (a(), l("tbody", Ui, [
              (a(!0), l(H, null, L(Zt.value, (_) => (a(), l("tr", {
                key: _.id,
                class: "tw-border-b tw-border-dorian-gray-100/80 tw-bg-white"
              }, [
                e.withSelect ? (a(), l("td", Wi, Qi)) : x("", !0),
                (a(!0), l(H, null, L(G.value, (z) => (a(), l("td", {
                  key: _[z],
                  class: "h-2 bg-slate-200 rounded tw-animate-pulse tw-whitespace-nowrap tw-px-6"
                }, Ki))), 128))
              ]))), 128))
            ])) : (a(), l("tbody", Ji, [
              J.value.length === 0 ? (a(), l("tr", Xi, td)) : x("", !0),
              (a(!0), l(H, null, L(J.value, (_, z) => {
                var N, q, X;
                return a(), l("tr", {
                  key: _.id,
                  class: p(["tw-border-b tw-border-dorian-gray-100/80", [
                    at.value === _.id && e.withRowClick ? "tw-bg-secondary-200" : "hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100",
                    e.zebra && z % 2 === 0 && at.value !== _.id ? "tw-bg-light" : "",
                    e.zebra && z % 2 !== 0 && at.value !== _.id ? "tw-bg-white" : ""
                  ]]),
                  onClick: (Z) => Kt(_)
                }, [
                  e.withSelect ? (a(), l("td", {
                    key: 0,
                    class: "tw-w-4 tw-px-4",
                    onClick: k[5] || (k[5] = $t(() => {
                    }, ["stop"]))
                  }, [
                    o("div", od, [
                      D(o("input", {
                        id: `select-${_.id}`,
                        "onUpdate:modelValue": k[4] || (k[4] = (Z) => $.value = Z),
                        "data-test-id": `${e.testId}-checkbox-selected-${_.id}`,
                        value: _,
                        type: "checkbox",
                        class: p({
                          "tw-h-4 tw-w-4 tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-100 tw-bg-dorian-gray-100 hover:tw-cursor-not-allowed dark:tw-border-dorian-gray-50": (N = _.metadata) == null ? void 0 : N.inherited,
                          "tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400": !((q = _.metadata) != null && q.inherited)
                        }),
                        disabled: (X = _.metadata) == null ? void 0 : X.inherited,
                        onChange: Dt
                      }, null, 42, sd), [
                        [K, $.value]
                      ]),
                      o("label", {
                        for: `select-${_.id}`,
                        class: "tw-sr-only"
                      }, "checkbox", 8, nd)
                    ])
                  ])) : x("", !0),
                  (a(!0), l(H, null, L(G.value, (Z) => (a(), l("td", {
                    key: _[Z],
                    class: p(["tw-relative tw-align-middle", Pt(Z)])
                  }, [
                    o("div", {
                      class: p(["tw-flex tw-whitespace-nowrap tw-py-1", At(Z)]),
                      onClick: st
                    }, [
                      f(g.$slots, `body.cell.${String(Z).toLocaleLowerCase()}`, {
                        tdValue: _[Z],
                        trItem: _
                      }, () => [
                        R(y(_[Z]), 1)
                      ])
                    ], 2)
                  ], 2))), 128))
                ], 10, ed);
              }), 128))
            ]))
          ])
        ], 512)
      ]),
      o("section", ad, [
        o("div", ld, [
          f(g.$slots, "pagination", {}, () => [
            o("div", rd, [
              o("div", id, [
                o("div", dd, [
                  o("div", cd, [
                    wd,
                    D(o("select", {
                      "onUpdate:modelValue": k[6] || (k[6] = (_) => c.value = _),
                      name: "rows-per-page",
                      class: "tw-focus:border-gray-200 peer tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-solid tw-border-dorian-gray-100/80 tw-bg-white tw-text-sm tw-text-dorian-gray-500 tw-outline-none focus:tw-border-secondary-500 focus:tw-ring-0",
                      onChange: Et
                    }, [
                      (a(!0), l(H, null, L(e.itemsPerPage, (_) => (a(), l("option", {
                        key: _,
                        value: _,
                        selected: _ === c.value
                      }, y(_), 9, hd))), 128))
                    ], 544), [
                      [kt, c.value]
                    ])
                  ]),
                  J.value.length !== 0 ? (a(), l("div", ud, [
                    o("span", pd, [
                      R(y(nt.value.start + 1) + "-" + y(nt.value.start + J.value.length) + " ", 1),
                      o("span", null, "of " + y(e.withServerSidePagination ? e.total : it.value.length), 1)
                    ])
                  ])) : x("", !0)
                ])
              ]),
              o("div", _d, [
                o("div", fd, [
                  o("button", {
                    class: "tw-bg-transparent tw-mr-[-1px] tw-rounded-l tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-r disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
                    disabled: v.value === Y,
                    onClick: Ft
                  }, [
                    bd,
                    I(u(ma), {
                      width: "16",
                      height: "16"
                    })
                  ], 8, gd),
                  o("button", {
                    class: "tw-bg-transparent tw-ml-[-1px] tw-rounded-r tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-l disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
                    disabled: v.value >= jt.value,
                    onClick: Nt
                  }, [
                    md,
                    I(u(It), {
                      width: "16",
                      height: "16"
                    })
                  ], 8, vd)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 64));
  }
}), x1 = /* @__PURE__ */ w({
  __name: "cl-data-table-edit-action",
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = t, n = () => {
      e("on-click");
    };
    return (d, r) => (a(), l("button", {
      type: "button",
      class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
      onClick: n
    }, [
      I(u(Fs), {
        width: "18",
        height: "18"
      })
    ]));
  }
}), $1 = /* @__PURE__ */ w({
  __name: "cl-data-table-view-action",
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = t, n = () => {
      e("on-click");
    };
    return (d, r) => (a(), l("button", {
      type: "button",
      class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
      onClick: n
    }, [
      I(u(Ys), {
        width: "18",
        height: "18"
      })
    ]));
  }
}), k1 = /* @__PURE__ */ w({
  __name: "cl-data-table-delete-action",
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = t, n = () => {
      e("on-click");
    };
    return (d, r) => (a(), l("button", {
      type: "button",
      class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
      onClick: n
    }, [
      I(u(Qn), {
        width: "18",
        height: "18"
      })
    ]));
  }
}), yd = { class: "tw-mb-0 tw-w-full tw-py-1 tw-text-base tw-font-normal tw-text-dorian-gray-500" }, C1 = /* @__PURE__ */ w({
  __name: "cl-data-table-more-action",
  setup(s) {
    const t = M(!1), e = M(null);
    W(e, () => {
      t.value && (t.value = !1);
    });
    const n = C(() => ["tw-top-6", t.value ? "tw-opacity-100" : "tw-opacity-0"]);
    return (d, r) => (a(), l("div", {
      ref_key: "target",
      ref: e,
      class: "wrap tw-relative tw-top-[3px] tw-inline-block tw-w-6"
    }, [
      o("button", {
        class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 focus:tw-bg-secondary-200 focus:tw-text-secondary-500 focus:tw-ring-secondary-200 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
        type: "button",
        onClick: r[0] || (r[0] = (i) => t.value = !t.value)
      }, [
        I(u(ea), {
          width: "18",
          height: "18"
        })
      ]),
      t.value ? (a(), l("div", {
        key: 0,
        class: p(["tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-shadow-md tw-transition-opacity", n.value]),
        onClick: r[1] || (r[1] = (i) => t.value = !1)
      }, [
        o("ul", yd, [
          f(d.$slots, "default")
        ])
      ], 2)) : x("", !0)
    ], 512));
  }
}), M1 = /* @__PURE__ */ w({
  __name: "cl-data-table-more-action-item",
  props: {
    bordered: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = s, n = C(() => [
      "tw-block tw-cursor-pointer tw-border-b tw-px-4 tw-py-2 tw-text-left",
      e.bordered ? "tw-border-dorian-gray-50" : "tw-border-none",
      e.disabled ? "tw-pointer-events-none tw-text-dorian-gray-200" : "hover:tw-bg-light"
    ]), d = t, r = () => {
      d("on-click");
    };
    return (i, c) => (a(), l("li", {
      class: p(n.value),
      onClick: r
    }, [
      f(i.$slots, "default")
    ], 2));
  }
}), B1 = /* @__PURE__ */ w({
  __name: "cl-pill",
  props: {
    variant: { default: "info" },
    size: { default: "xs" },
    uppercase: { type: Boolean, default: !0 }
  },
  setup(s) {
    const t = {
      info: "tw-border-info-500 tw-text-info-500",
      warning: "tw-border-warning-500 tw-text-warning-500",
      danger: "tw-border-danger-500 tw-text-danger-500",
      success: "tw-border-success-500 tw-text-success-500",
      infoFull: "tw-border-info-600 tw-bg-info-600 tw-text-white",
      successFull: "tw-border-success-500 tw-bg-success-500 tw-text-white"
    }, e = {
      xs: "tw-text-xs tw-px-2",
      sm: "tw-text-sm tw-px-2 tw-py-1"
    }, n = s, d = C(() => [
      "tw-rounded-2xl tw-border tw-border-solid tw-font-semibold tw-inline-block",
      t[n.variant],
      e[n.size],
      n.uppercase && "tw-uppercase"
    ]);
    return (r, i) => (a(), l("span", {
      class: p(d.value)
    }, [
      f(r.$slots, "default")
    ], 2));
  }
}), xd = ["data-test-id"], $d = { class: "tw-grid tw-grid-flow-row" }, kd = {
  key: 0,
  class: "tw-p-4"
}, Cd = {
  key: 1,
  class: "tw-p-4"
}, Md = {
  key: 2,
  class: "tw-bg-light tw-p-4"
}, I1 = /* @__PURE__ */ w({
  __name: "cl-card",
  props: {
    dataTestId: { default: "" },
    title: { default: "" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("div", {
      class: "tw-block tw-rounded-sm tw-bg-white tw-shadow",
      "data-test-id": t.dataTestId
    }, [
      o("div", $d, [
        e.$slots.title || t.title !== "" ? (a(), l("div", kd, [
          e.$slots.title ? f(e.$slots, "title", { key: 0 }) : (a(), A(u(ut), {
            key: 1,
            size: "h6",
            class: "tw-mb-0"
          }, {
            default: F(() => [
              R(y(t.title), 1)
            ]),
            _: 1
          }))
        ])) : x("", !0),
        e.$slots.text ? (a(), l("div", Cd, [
          f(e.$slots, "text")
        ])) : x("", !0),
        e.$slots.footer ? (a(), l("div", Md, [
          f(e.$slots, "footer")
        ])) : x("", !0)
      ])
    ], 8, xd));
  }
}), Bd = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Loading...", -1), xt = /* @__PURE__ */ w({
  __name: "cl-skeleton",
  props: {
    size: { default: "sm" }
  },
  setup(s) {
    const t = {
      sm: "tw-max-w-sm"
    }, e = s, n = C(() => [t[e.size], "tw-animate-pulse"]);
    return (d, r) => (a(), l("div", {
      role: "status",
      class: p(n.value)
    }, [
      f(d.$slots, "default"),
      Bd
    ], 2));
  }
}), z1 = /* @__PURE__ */ w({
  __name: "cl-skeleton-row",
  props: {
    width: { default: "xs" },
    bg: { default: "default" }
  },
  setup(s) {
    const t = {
      xs: "tw-max-w-[270px]",
      sm: "tw-max-w-[300px]",
      md: "tw-max-w-[330px]",
      lg: "tw-max-w-[360px]"
    }, e = {
      light: "tw-bg-dorian-gray-50",
      default: "tw-bg-dorian-gray-100"
    }, n = s, d = C(() => [
      t[n.width],
      "tw-mb-4 tw-h-2.5 tw-rounded-full",
      e[n.bg]
    ]);
    return (r, i) => (a(), l("div", {
      class: p([d.value, "w-48"])
    }, null, 2));
  }
}), Id = ["href", "data-test-id"], zd = { class: "tw-relative tw-grid tw-grid-cols-2 tw-gap-4" }, Td = { class: "tw-col-span-1 tw-flex tw-flex-col tw-items-start tw-self-start" }, Hd = { class: "tw-col-span-1 tw-flex tw-flex-col tw-items-end tw-self-end" }, T1 = /* @__PURE__ */ w({
  __name: "cl-card-trend",
  props: {
    loading: { type: Boolean, default: !1 },
    href: { default: () => ({
      title: "title",
      url: "nameRoute",
      navigate: () => {
      }
    }) },
    testId: { default: "" }
  },
  setup(s) {
    const t = M(!1), e = rt(), n = s;
    function d(r) {
      t.value = r;
    }
    return (r, i) => {
      const c = Ct("cl-skeleton-row");
      return a(), l("div", {
        class: p([t.value ? "hover:tw-shadow-lg" : "tw-shadow", "tw-relative tw-flex tw-h-36 tw-w-full tw-flex-col tw-justify-between tw-rounded-sm tw-bg-white tw-p-6"])
      }, [
        I(u(ut), {
          class: "tw-flex tw-items-center",
          size: "h6"
        }, {
          default: F(() => [
            f(r.$slots, "title", {}, () => [
              o("a", {
                class: "tw-text-lg tw-font-semibold tw-text-dorian-gray-500 hover:tw-text-secondary-500",
                href: n.href.url,
                "data-test-id": n.testId,
                onMouseover: i[0] || (i[0] = (h) => d(!0)),
                onMouseleave: i[1] || (i[1] = (h) => d(!1)),
                onClick: i[2] || (i[2] = //@ts-ignore
                (...h) => n.href.navigate && n.href.navigate(...h))
              }, y(n.href.title), 41, Id)
            ]),
            u(e).title ? x("", !0) : (a(), A(u(It), {
              key: 0,
              class: p([
                t.value ? "tw-text-secondary-500" : "tw-text-dorian-gray-500",
                "tw-ml-1 tw-inline"
              ]),
              width: "20",
              height: "20"
            }, null, 8, ["class"]))
          ]),
          _: 3
        }),
        o("div", zd, [
          o("div", Td, [
            n.loading ? (a(), A(u(xt), {
              key: 0,
              class: "tw-w-full"
            }, {
              default: F(() => [
                I(c)
              ]),
              _: 1
            })) : f(r.$slots, "footer-left", { key: 1 })
          ]),
          o("div", Hd, [
            n.loading ? (a(), A(u(xt), {
              key: 0,
              class: "tw-w-full"
            }, {
              default: F(() => [
                I(c, { bg: "light" })
              ]),
              _: 1
            })) : f(r.$slots, "footer-right", { key: 1 })
          ])
        ])
      ], 2);
    };
  }
}), Sd = ["aria-hidden"], jd = { class: "tw-relative tw-rounded-lg tw-bg-white tw-shadow dark:tw-bg-light" }, Ld = { class: "tw-flex tw-items-start tw-justify-between tw-border-b tw-border-dorian-gray-50 tw-p-4 dark:tw-border-dorian-gray-100" }, Vd = ["data-test-id"], Pd = /* @__PURE__ */ o("svg", {
  "aria-hidden": "true",
  class: "tw-h-5 tw-w-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ o("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1), Ad = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Close modal", -1), Od = [
  Pd,
  Ad
], Dd = { class: "tw-max-h-[70vh] tw-space-y-6 tw-overflow-y-scroll tw-p-6" }, Nd = { class: "tw-flex tw-items-center tw-justify-end tw-space-x-2 tw-border-t tw-border-dorian-gray-50 tw-p-6 dark:tw-border-dorian-gray-100" }, H1 = /* @__PURE__ */ w({
  __name: "cl-modal",
  props: {
    visible: { type: Boolean },
    testId: { default: "default-test-id" },
    headerLabel: { default: "Modal" },
    acceptLabel: { default: "Accept" },
    declineLabel: { default: "Decline" },
    size: { default: "md" }
  },
  emits: ["on-close", "on-accept", "on-decline"],
  setup(s, { emit: t }) {
    const e = s, n = M(null);
    W(n, () => c("on-close"));
    const d = C(() => e.visible ? "tw-visible  tw-opacity-1" : "tw-invisible  tw-opacity-0"), r = {
      sm: "tw-max-w-1xl",
      md: "tw-max-w-2xl",
      lg: "tw-max-w-3xl",
      xl: "tw-max-w-4xl",
      xxl: "tw-max-w-5xl"
    }, i = C(() => [r[e.size]]), c = t, h = () => {
      c("on-close");
    }, b = () => {
      c("on-accept");
    }, m = () => {
      c("on-decline");
    };
    return ($, v) => (a(), l("div", {
      tabindex: "-1",
      "aria-hidden": !d.value,
      class: p(["tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-50 tw-max-h-full tw-w-full tw-bg-[#000000]/50 tw-transition-all dark:tw-bg-[#000000]/80", d.value])
    }, [
      o("div", {
        ref_key: "target",
        ref: n,
        class: p(["tw-fixed tw-left-1/2 tw-top-1/2 tw-max-h-full tw-w-full tw--translate-x-1/2 tw--translate-y-1/2", i.value])
      }, [
        o("div", jd, [
          o("div", Ld, [
            f($.$slots, "header.title", {}, () => [
              I(u(ut), { size: "h4" }, {
                default: F(() => [
                  R(y(e.headerLabel), 1)
                ]),
                _: 1
              })
            ]),
            o("button", {
              type: "button",
              class: "tw-bg-transparent tw-ml-auto tw-inline-flex tw-items-center tw-rounded-md tw-p-1.5 tw-text-sm tw-text-dorian-gray-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-bg-dorian-gray-50 focus:tw-outline-4 focus:tw-outline-dorian-gray-200/20 active:tw-bg-dorian-gray-100 active:tw-text-dorian-gray-500",
              "data-test-id": `${e.testId}-close`,
              onClick: h
            }, Od, 8, Vd)
          ]),
          o("div", Dd, [
            f($.$slots, "breadcrumbs"),
            f($.$slots, "default")
          ]),
          o("div", Nd, [
            f($.$slots, "footer.decline", {}, () => [
              I(u(ct), {
                "data-test-id": `${e.testId}-${e.declineLabel}-button`,
                variant: "link-secondary",
                onOnClick: m
              }, {
                default: F(() => [
                  R(y(e.declineLabel), 1)
                ]),
                _: 1
              }, 8, ["data-test-id"])
            ]),
            f($.$slots, "footer.accept", {}, () => [
              I(u(ct), {
                variant: "secondary",
                "data-test-id": `${e.testId}-${e.acceptLabel}-button`,
                onOnClick: b
              }, {
                default: F(() => [
                  R(y(e.acceptLabel), 1)
                ]),
                _: 1
              }, 8, ["data-test-id"])
            ])
          ])
        ])
      ], 2)
    ], 10, Sd));
  }
}), Fd = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Dropdown", -1), Ed = { class: "tw-flex tw-items-center" }, Zd = { class: "tw-mb-0 tw-w-full tw-py-1 tw-text-base tw-font-normal tw-text-dorian-gray-500" }, S1 = /* @__PURE__ */ w({
  __name: "cl-dropdown",
  props: {
    title: {},
    position: { default: "bottom" },
    testId: { default: "cl-dropdown-toggle-btn" },
    disabled: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = {
      top: "tw-bottom-12",
      bottom: "tw-top-12"
    }, n = M(!1), d = M(null);
    W(d, () => {
      n.value && (n.value = !1);
    });
    const r = C(() => [
      e[t.position],
      n.value ? "tw-opacity-100" : "tw-opacity-0"
    ]);
    return (i, c) => (a(), l("div", {
      ref_key: "target",
      ref: d,
      class: "wrap tw-relative tw-w-fit"
    }, [
      I(u(ct), {
        variant: "secondary",
        "data-test-id": t.testId,
        disabled: i.disabled,
        onClick: c[0] || (c[0] = (h) => n.value = !n.value)
      }, {
        default: F(() => [
          Fd,
          o("div", Ed, [
            R(y(t.title) + " ", 1),
            I(u(ot), {
              class: p(["tw-transition-transform", n.value ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])
          ])
        ]),
        _: 1
      }, 8, ["data-test-id", "disabled"]),
      n.value ? (a(), l("div", {
        key: 0,
        class: p(["tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-shadow-md tw-transition-opacity", r.value]),
        onClick: c[1] || (c[1] = (h) => n.value = !1)
      }, [
        o("ul", Zd, [
          f(i.$slots, "default")
        ])
      ], 2)) : x("", !0)
    ], 512));
  }
}), j1 = /* @__PURE__ */ w({
  __name: "cl-dropdown-item",
  props: {
    bordered: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = s, n = C(() => [
      "tw-block tw-cursor-pointer tw-border-b tw-px-4 tw-py-2 tw-text-left",
      e.bordered ? "tw-border-dorian-gray-50" : "tw-border-none",
      e.disabled ? "tw-pointer-events-none tw-text-dorian-gray-200" : "hover:tw-bg-light"
    ]), d = t, r = () => {
      d("on-click");
    };
    return (i, c) => (a(), l("li", {
      class: p(n.value),
      onClick: r
    }, [
      f(i.$slots, "default")
    ], 2));
  }
}), Rd = {}, Ud = { class: "tw-relative" }, Wd = { class: "tw--mb-px tw-flex tw-flex-wrap tw-text-center" };
function Gd(s, t) {
  return a(), l("div", Ud, [
    o("ul", Wd, [
      f(s.$slots, "default")
    ])
  ]);
}
const L1 = /* @__PURE__ */ j(Rd, [["render", Gd]]), V1 = /* @__PURE__ */ w({
  __name: "cl-tabs-item",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = s, { active: n, disabled: d } = P(e), r = C(() => [
      "tw-mb-2 tw-mr-4 tw-select-none",
      d.value ? "tw-pointer-events-none tw-text-dorian-gray-200" : "tw-text-dorian-gray-500 hover:tw-cursor-pointer",
      n.value ? "hover:tw-cursor-default" : "hover:tw-cursor-pointer"
    ]), i = C(() => [
      "tw-inline-block tw-border-b-2 tw-text-base tw-font-medium",
      n.value ? "tw-border-secondary-500 tw-text-secondary-500 hover:tw-cursor-default" : "tw-border-secondary-500/0 hover:tw-border-secondary-500"
    ]), c = t, h = () => {
      c("on-click");
    };
    return (b, m) => (a(), l("li", {
      class: p(r.value),
      onClick: h
    }, [
      o("span", {
        class: p(i.value)
      }, [
        f(b.$slots, "default")
      ], 2)
    ], 2));
  }
}), P1 = /* @__PURE__ */ w({
  __name: "cl-badge",
  props: {
    variant: { default: "info" },
    size: { default: "base" }
  },
  setup(s) {
    const t = {
      info: "tw-bg-info-100",
      warning: "tw-bg-warning-200",
      danger: "tw-bg-danger-100"
    }, e = {
      sm: "tw-px-1",
      base: "tw-px-2 tw-py-1"
    }, n = s, d = C(() => [
      "tw-inline-flex tw-items-center tw-rounded",
      t[n.variant],
      e[n.size]
    ]);
    return (r, i) => (a(), l("span", {
      class: p([d.value, ""])
    }, [
      f(r.$slots, "default")
    ], 2));
  }
}), A1 = /* @__PURE__ */ w({
  __name: "cl-badge-label",
  setup(s) {
    const t = C(() => [
      "tw-m-1 tw-rounded tw-bg-white tw-px-1 tw-pt-0.5 tw-text-xs tw-font-normal tw-uppercase"
    ]);
    return (e, n) => (a(), l("span", {
      class: p(t.value)
    }, [
      f(e.$slots, "default")
    ], 2));
  }
}), Qd = { class: "tw-mb-3 tw-mr-3 tw-inline-flex tw-h-12 tw-w-48 tw-items-center tw-justify-between tw-rounded tw-border tw-border-dorian-gray-200 tw-bg-white" }, qd = { class: "tw-ml-1 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center" }, Kd = { class: "tw-w-[118px] tw-px-1" }, Jd = { class: "tw-w-[118px]" }, Xd = { class: "tw-text-xs tw-font-bold tw-text-dorian-gray-500" }, Yd = { class: "tw-flex tw-justify-between tw-text-xs tw-text-dorian-gray-500" }, tc = { class: "tw-mr-2 tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-end" }, ec = ["href", "data-test-id"], O1 = /* @__PURE__ */ w({
  __name: "cl-email-attachment",
  props: {
    link: {},
    name: {},
    extension: {},
    size: {},
    testId: { default: "cl-attachment-download-link" }
  },
  setup(s) {
    const t = s, e = C(() => `${t.name.substring(0, 16)}...`);
    return (n, d) => (a(), l("div", Qd, [
      o("div", qd, [
        I(u(Ts), {
          width: "24",
          height: "24"
        })
      ]),
      o("div", Kd, [
        o("div", Jd, [
          I(u(St), {
            id: t.name,
            text: t.name
          }, {
            default: F(() => [
              o("span", Xd, y(e.value), 1)
            ]),
            _: 1
          }, 8, ["id", "text"])
        ]),
        o("div", Yd, [
          o("span", null, y(t.extension), 1),
          o("span", null, y(t.size), 1)
        ])
      ]),
      o("div", tc, [
        o("a", {
          href: t.link,
          "data-test-id": t.testId,
          target: "_blank",
          class: "tw-text-dorian-gray-500 hover:tw-text-secondary-500"
        }, [
          I(u(ys), {
            width: "18",
            height: "18"
          })
        ], 8, ec)
      ])
    ]));
  }
}), oc = { class: "tw-inline-flex tw-cursor-pointer tw-items-center tw-rounded-md tw-p-2" }, D1 = /* @__PURE__ */ w({
  __name: "cl-switcher",
  props: {
    options: { default: () => ["Yes", "No"] },
    selectedValue: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = M(e.selectedValue);
    return S(d, (r) => {
      n("update:selected", r);
    }), S(
      () => e.selectedValue,
      () => {
        d.value = e.selectedValue;
      }
    ), (r, i) => (a(), l("label", oc, [
      D(o("input", {
        "onUpdate:modelValue": i[0] || (i[0] = (c) => d.value = c),
        type: "checkbox",
        class: "tw-peer tw-hidden"
      }, null, 512), [
        [K, d.value]
      ]),
      o("div", {
        class: p([!r.selectedValue && "dark:tw-text-dorian-gray-300", "tw-rounded-l-md tw-bg-dorian-gray-100 tw-px-4 tw-py-2 tw-font-bold tw-text-white peer-checked:tw-bg-secondary-500"])
      }, y(r.options[0]), 3),
      o("div", {
        class: p([r.selectedValue && "dark:tw-text-dorian-gray-300", "tw-rounded-r-md tw-border-secondary-500 tw-bg-secondary-500 tw-px-4 tw-py-2 tw-font-bold tw-text-white peer-checked:tw-bg-dorian-gray-100"])
      }, y(r.options[1]), 3)
    ]));
  }
}), sc = (s, t) => {
  const e = (r) => r.split(" ").map(
    (h) => h.charAt(0).toUpperCase() + h.slice(1).toLowerCase()
  ).join(" "), n = (r, i) => {
    let c = i;
    return r.mspName && (c = c.replace(/^Msp$/, r.mspName)), r.customerName && (c = c.replace(/^Customer$/, r.customerName)), r.domainName && (c = c.replace(/^Domain$/, r.domainName)), r.userName && (c = c.replace(/^User$/, r.userName)), c;
  }, d = `${s.parentPath}${t}`.split("/");
  return d.map((r) => n(s, e(r))).reduce((r, i, c) => {
    if (c === 0)
      return [];
    const h = d[c];
    return [
      ...r,
      {
        text: /^\d+$/.test(i) ? s.title : e(
          i.replace(/[_ -]/g, " ").replace(/%20/g, " ")
        ),
        to: c === 1 ? `/${h}` : `${r[c - 2].to}/${h}`
      }
    ];
  }, []);
}, nc = { class: "tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-p-0" }, ac = ["onClick"], N1 = /* @__PURE__ */ w({
  __name: "cl-breadcrumbs",
  props: {
    pageMeta: {},
    routePath: {}
  },
  emits: ["on-click"],
  setup(s, { emit: t }) {
    const e = s, n = C(() => sc(e.pageMeta, e.routePath)), d = t, r = (i) => {
      d("on-click", i);
    };
    return (i, c) => (a(), l("ol", nc, [
      (a(!0), l(H, null, L(n.value, (h) => (a(), l("li", {
        key: h.to,
        class: "tw-text-md :after:tw-font-normal after:tw-pl-1 after:tw-pr-1 after:tw-text-dorian-gray-500 [&:not(:last-child)]:tw-cursor-pointer [&:not(:last-child)]:tw-font-bold [&:not(:last-child)]:tw-text-secondary-500 [&:not(:last-child)]:after:tw-content-['/']",
        onClick: (b) => r(h.to)
      }, y(h.text), 9, ac))), 128))
    ]));
  }
}), lc = { class: "tw-flex tw-items-center tw-gap-2" }, rc = ["id", "value", "data-test-id", "disabled"], ic = ["for"], F1 = /* @__PURE__ */ w({
  __name: "cl-checkbox",
  props: {
    id: {},
    value: { type: Boolean },
    modelValue: { type: [Boolean, Array] },
    round: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    testId: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = rt(), r = C({
      get() {
        return e.modelValue;
      },
      set(i) {
        n("update:modelValue", i);
      }
    });
    return (i, c) => (a(), l("div", lc, [
      D(o("input", {
        id: e.id,
        "onUpdate:modelValue": c[0] || (c[0] = (h) => r.value = h),
        type: "checkbox",
        class: p(["tw-h-5 tw-w-5 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400", {
          "tw-rounded-full": i.round
        }]),
        value: i.value,
        "data-test-id": i.testId,
        disabled: i.disabled
      }, null, 10, rc), [
        [K, r.value]
      ]),
      u(d).default ? (a(), l("label", {
        key: 0,
        for: i.id,
        class: "tw-mb-0 tw-cursor-pointer"
      }, [
        f(i.$slots, "default")
      ], 8, ic)) : x("", !0)
    ]));
  }
}), dc = { class: "tw-flex tw-flex-row" }, cc = ["data-test-id"], wc = ["id", "name", "checked", "disabled", "onChange"], hc = ["for", "data-test-id"], E1 = /* @__PURE__ */ w({
  __name: "cl-form-radio-group",
  props: {
    dataTestId: { default: "" },
    id: { default: "" },
    options: {},
    selectedValue: { type: [String, Boolean, Number], default: void 0 },
    button: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "medium" }
  },
  emits: ["update:selected"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = {
      radio: "tw-bg-white tw-border-dorian-gray-500 tw-border-dorian-gray-70 tw-my-2 tw-ml-4 tw-mr-2 tw-h-5 tw-w-5 tw-cursor-pointer tw-border-2 tw-border-solid tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white",
      button: "tw-sr-only tw-invisible tw-peer"
    }, r = {
      radio: "tw-text-base tw-cursor-pointer tw-m-0",
      button: "tw-m-0 tw-text-secondary-500 tw-font-bold peer-checked:tw-bg-secondary-500 tw-border-secondary-500 peer-checked:tw-text-white tw-flex tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-secondary-200 hover:tw-text-secondary-600"
    }, i = M(e.selectedValue), c = M(
      e.id ? e.id : (Math.random() + 1).toString(36).substring(2)
    ), h = C(() => e.button ? [d.button] : [d.radio]), b = C(() => e.button ? [r.button] : [r.radio]);
    S(
      () => e.selectedValue,
      () => {
        i.value = e.selectedValue;
      }
    );
    const m = ($) => {
      n("update:selected", $);
    };
    return ($, v) => (a(), l("div", dc, [
      (a(!0), l(H, null, L(e.options, (B, T) => (a(), l("div", {
        key: T,
        class: "tw-flex tw-items-center",
        "data-test-id": e.dataTestId
      }, [
        o("input", {
          id: `${c.value}-${B.value}`,
          type: "radio",
          name: `${c.value}-name`,
          class: p(h.value),
          checked: B.value === i.value,
          disabled: e.disabled,
          onChange: (st) => m(B.value)
        }, null, 42, wc),
        o("label", {
          for: `${c.value}-${B.value}`,
          "data-test-id": `${e.dataTestId}-${B.label}`,
          class: p([
            b.value,
            {
              "tw-text-sm": e.size === "small",
              "tw-rounded-l tw-border-2": T === 0 && e.button,
              "tw-rounded-r tw-border-b-2 tw-border-r-2 tw-border-t-2": T === $.options.length - 1 && e.button,
              "tw-border-b-2 tw-border-r-2 tw-border-t-2": T !== $.options.length - 1 && T !== 0 && e.button
            }
          ])
        }, y(B.label), 11, hc)
      ], 8, cc))), 128))
    ]));
  }
}), uc = { class: "tw-flex-grow" }, pc = { class: "tw-text-lg tw-font-semibold" }, Z1 = /* @__PURE__ */ w({
  __name: "cl-toast",
  props: {
    id: {},
    title: {},
    message: {},
    variant: { default: "success" }
  },
  emits: ["on-close"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = (i) => {
      n("on-close", i);
    }, r = C(() => e.variant === "success");
    return (i, c) => (a(), l("div", {
      class: p([
        "tw-z-[55] tw-flex tw-w-80 tw-items-start tw-justify-between tw-gap-3 tw-rounded-sm tw-border-2 tw-p-3",
        r.value ? "tw-border-success-500 tw-bg-success-100" : "tw-border-danger-500 tw-bg-danger-100"
      ]),
      role: "alert"
    }, [
      o("div", {
        class: p(r.value ? "tw-text-success-500" : "tw-text-danger-500")
      }, [
        I(u(zt))
      ], 2),
      o("div", uc, [
        o("div", pc, y(i.title), 1),
        o("div", null, y(i.message), 1)
      ]),
      o("button", {
        class: "tw-inline-flex",
        "aria-label": "Close",
        onClick: c[0] || (c[0] = (h) => d(i.id))
      }, [
        I(u(Tt))
      ])
    ], 2));
  }
}), _c = ["data-test-id"], fc = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, "Account Dropdown", -1), gc = { class: "tw-relative tw-flex tw-min-h-[58px] tw-w-full tw-items-center tw-justify-start tw-rounded-t tw-bg-aside-300 tw-p-2 dark:tw-bg-dorian-gray-100" }, bc = { class: "tw-text-lg tw-font-medium tw-text-white dark:tw-text-dorian-gray-500" }, vc = { class: "tw-relative tw-p-1 tw-pt-0" }, mc = { class: "tw-mb-0 tw-w-full tw-text-base tw-font-normal tw-text-dorian-gray-500" }, yc = {
  key: 0,
  class: "tw-relative tw-border-t tw-border-t-dorian-gray-50 tw-px-2 tw-py-2 dark:tw-border-t-dorian-gray-100"
}, xc = { class: "tw-relative tw-p-1 tw-pt-0" }, $c = { class: "tw-mb-0 tw-w-full tw-text-base tw-font-normal tw-text-dorian-gray-500" }, R1 = /* @__PURE__ */ w({
  __name: "cl-header-dropdown",
  props: {
    dataTestId: { default: "" }
  },
  setup(s) {
    const t = s, e = M(!1), n = M(null);
    return W(n, () => {
      e.value && (e.value = !1);
    }), (d, r) => (a(), l("div", {
      ref_key: "target",
      ref: n,
      class: "tw-relative tw-z-20 tw-h-12 tw-w-12"
    }, [
      o("button", {
        class: "tw-relative tw-z-30 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-dorian-gray-500 tw-shadow-md tw-outline-0 -tw-outline-offset-4 tw-outline-aside-300 hover:tw-text-dorian-gray-300 focus:tw-outline-2 focus-visible:tw-outline-2 active:tw-shadow-none",
        type: "button",
        "data-test-id": t.dataTestId,
        onClick: r[0] || (r[0] = (i) => e.value = !e.value)
      }, [
        fc,
        I(u(Wa))
      ], 8, _c),
      e.value ? (a(), l("div", {
        key: 0,
        class: "tw-absolute tw-right-[-6px] tw-top-[-6px] tw-z-20 tw-flex tw-min-w-[368px] tw-flex-col tw-rounded tw-border-dorian-gray-100 tw-bg-white tw-shadow-md",
        onClick: r[1] || (r[1] = (i) => e.value = !1)
      }, [
        o("div", gc, [
          o("span", bc, [
            f(d.$slots, "title")
          ])
        ]),
        o("div", vc, [
          o("ul", mc, [
            f(d.$slots, "products")
          ])
        ]),
        d.$slots.appearance ? (a(), l("div", yc, [
          f(d.$slots, "appearance")
        ])) : x("", !0),
        o("div", xc, [
          o("ul", $c, [
            f(d.$slots, "links")
          ])
        ])
      ])) : x("", !0)
    ], 512));
  }
}), kc = { class: "tw-relative tw-my-0.5 tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-start tw-bg-white" }, Cc = ["href", "data-test-id"], Mc = { class: "tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-between" }, Bc = { class: "tw-text-lg tw-font-bold tw-text-dorian-gray-500" }, U1 = /* @__PURE__ */ w({
  __name: "cl-header-dropdown-product",
  props: {
    link: {},
    active: { type: Boolean, default: !1 },
    label: { default: "" },
    dataTestId: { default: "" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("li", kc, [
      o("a", {
        href: t.link,
        "data-test-id": t.dataTestId,
        target: "_blank",
        class: p(["tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-white tw-px-2 tw-py-4 tw-no-underline tw-transition-colors hover:tw-bg-dorian-gray-50/40 dark:hover:tw-bg-dorian-gray-100/60", {
          "tw-pointer-events-none tw-border tw-border-secondary-500 tw-bg-secondary-50": t.active
        }])
      }, [
        o("figure", Mc, [
          f(e.$slots, "default"),
          o("figcaption", Bc, [
            R(y(t.label) + " ", 1),
            t.active ? (a(), A(u(Fl), { key: 0 })) : x("", !0)
          ])
        ])
      ], 10, Cc)
    ]));
  }
}), Ic = { class: "tw-relative tw-my-0.5 tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-start tw-border-t tw-border-t-dorian-gray-50 tw-bg-white tw-pb-2 tw-pt-2 dark:tw-border-t-dorian-gray-100" }, zc = ["href", "target", "data-test-id"], Tc = { class: "tw-relative tw-inline-flex tw-items-center tw-justify-start" }, Hc = { class: "tw-font-normal tw-text-dorian-gray-500" }, Sc = { class: "tw-ml-4 tw-font-normal tw-text-dorian-gray-500" }, W1 = /* @__PURE__ */ w({
  __name: "cl-header-dropdown-link",
  props: {
    label: {},
    link: {},
    target: { default: "_self" },
    dataTestId: { default: "" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("li", Ic, [
      o("a", {
        class: "tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-white tw-px-2 tw-py-2 tw-no-underline tw-transition-colors hover:tw-bg-dorian-gray-50/40 dark:hover:tw-bg-dorian-gray-100/60",
        href: t.link,
        target: t.target,
        "data-test-id": t.dataTestId
      }, [
        o("div", Tc, [
          o("span", Hc, [
            f(e.$slots, "default")
          ]),
          o("span", Sc, y(e.label), 1)
        ])
      ], 8, zc)
    ]));
  }
}), jc = ["id", "name", "rows", "maxlength", "autofocus", "placeholder", "disabled", "readonly", "data-test-id"], Lc = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", Vc = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", Pc = "read-only:tw-cursor-default read-only:tw-bg-dorian-gray-50 read-only:tw-text-dorian-gray-500/50 read-only:tw-outline-none", G1 = /* @__PURE__ */ w({
  __name: "cl-form-textarea",
  props: {
    id: {},
    name: {},
    value: {},
    placeholder: { default: "" },
    state: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 },
    testId: { default: "" },
    rows: { default: 3 },
    maxLength: { default: void 0 },
    size: { default: "medium" }
  },
  emits: ["update:value", "on-blur"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = M(e.value), r = {
      small: "tw-text-sm tw-py-1 tw-px-3",
      medium: "tw-text-base tw-py-2 tw-px-3",
      large: "tw-text-lg tw-py-3 tw-px-3"
    }, i = {
      none: "tw-border-dorian-gray-100/80",
      valid: "tw-border-success-500",
      error: "tw-border-danger-500"
    }, c = C(() => [
      r[e.size],
      e.state === null ? i.none : e.state ? i.valid : i.error,
      Lc,
      Vc,
      Pc
    ]);
    S(
      () => e.value,
      () => {
        d.value = e.value;
      }
    ), S(d, (b) => {
      n("update:value", b);
    });
    const h = () => {
      n("on-blur");
    };
    return (b, m) => D((a(), l("textarea", {
      id: e.id,
      "onUpdate:modelValue": m[0] || (m[0] = ($) => d.value = $),
      class: p(["tw-block tw-w-full tw-rounded tw-border tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", [c.value]]),
      name: e.name,
      rows: e.rows,
      maxlength: e.maxLength,
      autofocus: e.autofocus,
      placeholder: e.placeholder,
      disabled: e.disabled,
      readonly: e.readonly,
      "data-test-id": e.testId,
      onBlur: h
    }, null, 42, jc)), [
      [wt, d.value]
    ]);
  }
}), Ac = ["value"], Oc = /* @__PURE__ */ w({
  __name: "cl-form-select-options",
  props: {
    options: {}
  },
  setup(s) {
    return (t, e) => (a(!0), l(H, null, L(t.options, (n) => (a(), l("option", {
      key: n.value,
      value: n.value
    }, y(n.text), 9, Ac))), 128));
  }
}), Dc = ["label"], Nc = ["value"], Fc = /* @__PURE__ */ w({
  __name: "cl-form-select-options-group",
  props: {
    options: {}
  },
  setup(s) {
    return (t, e) => (a(!0), l(H, null, L(t.options, (n, d) => (a(), l("optgroup", {
      key: d,
      label: n.label
    }, [
      (a(!0), l(H, null, L(n.options, (r) => (a(), l("option", {
        key: r.value,
        value: r.value
      }, y(r.text), 9, Nc))), 128))
    ], 8, Dc))), 128));
  }
}), Ec = ["id", "name", "data-test-id", "autofocus", "options", "disabled"], Zc = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", Rc = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", Q1 = /* @__PURE__ */ w({
  __name: "cl-form-select",
  props: {
    id: {},
    name: {},
    value: {},
    testId: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    options: {},
    size: { default: "medium" }
  },
  emits: ["update:value", "change"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = M(e.value), r = (m) => !!(m && m[0].options && m[0].label), i = (m) => !!(m && m[0].text && m[0].value), c = {
      small: "tw-text-sm tw-py-1 tw-px-3",
      medium: "tw-text-base tw-py-2 tw-px-3",
      large: "tw-text-lg tw-py-3 tw-px-3"
    }, h = C(() => [c[e.size], Zc, Rc]);
    S(
      () => e.value,
      () => {
        d.value = e.value;
      }
    ), S(d, (m) => {
      n("update:value", m);
    });
    const b = (m) => {
      n("change", m);
    };
    return (m, $) => D((a(), l("select", {
      id: m.id,
      "onUpdate:modelValue": $[0] || ($[0] = (v) => d.value = v),
      class: p(["tw-block tw-w-full tw-rounded tw-border tw-border-dorian-gray-100 tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", [h.value]]),
      name: m.name,
      "data-test-id": m.testId,
      autofocus: m.autofocus,
      options: m.options,
      disabled: m.disabled,
      onChange: $[1] || ($[1] = (v) => b(d.value))
    }, [
      r(m.options) ? (a(), A(Fc, {
        key: 0,
        options: m.options
      }, null, 8, ["options"])) : x("", !0),
      i(m.options) ? (a(), A(Oc, {
        key: 1,
        options: m.options
      }, null, 8, ["options"])) : x("", !0)
    ], 42, Ec)), [
      [kt, d.value]
    ]);
  }
}), Uc = { class: "tw-relative tw-overflow-auto" }, Wc = { class: "tw-flex tw-w-full tw-items-center tw-text-center" }, Gc = ["onClick"], q1 = /* @__PURE__ */ w({
  __name: "cl-stepper",
  props: {
    steps: {}
  },
  emits: ["on-Click"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = (r) => {
      n("on-Click", r);
    };
    return (r, i) => (a(), l("div", Uc, [
      o("ol", Wc, [
        (a(!0), l(H, null, L(e.steps, (c, h) => (a(), l("li", {
          key: c.index,
          class: p(["tw-relative tw-flex tw-items-center", {
            "after:tw-border-1 after:tw-mx-6 after:tw-hidden after:tw-h-1 after:tw-w-full after:tw-border-b after:tw-border-dorian-gray-100 sm:after:tw-inline-block sm:after:tw-content-[''] md:tw-w-full xl:after:tw-mx-10": h !== e.steps.length - 1
          }])
        }, [
          o("span", {
            class: p(["tw-relative tw-flex tw-items-center tw-text-dorian-gray-500", {
              "after:tw-mx-2 after:tw-text-dorian-gray-100 after:tw-content-['/'] sm:after:tw-hidden": h !== e.steps.length - 1
            }])
          }, [
            c.completed ? (a(), A(u(nl), {
              key: 0,
              width: "16px",
              height: "16px",
              class: "tw-select-none tw-text-secondary-500"
            })) : (a(), l("span", {
              key: 1,
              class: p(["tw-select-none tw-text-base tw-font-medium", {
                "tw-text-secondary-500": c.current
              }])
            }, y(c.index), 3)),
            o("span", {
              class: p(["tw-ml-2.5 tw-inline-flex tw-whitespace-nowrap tw-text-base tw-font-medium tw-underline-offset-1 hover:tw-cursor-pointer hover:tw-underline", {
                "tw-text-dorian-gray-200": c.completed,
                "tw-text-secondary-500": c.current,
                "tw-pointer-events-none": !c.actionable
              }]),
              onClick: (b) => d(c.index)
            }, y(c.label), 11, Gc)
          ], 2)
        ], 2))), 128))
      ])
    ]));
  }
}), Qc = ["id"], qc = {
  key: 0,
  class: "w-relative tw-mb-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-2"
}, Kc = {
  key: 0,
  class: "w-relative tw-col-span-1 tw-mb-4 tw-flex tw-justify-start"
}, Jc = ["src"], Xc = { class: "w-relative tw-col-span-1 tw-flex tw-justify-start md:tw-justify-end" }, Yc = { class: "tw-flex tw-flex-col" }, t0 = {
  key: 0,
  class: "tw-mb-2 tw-text-base tw-font-normal tw-text-white dark:tw-text-dorian-gray-500"
}, e0 = ["href", "data-test-id"], o0 = { class: "tw-inline-flex tw-h-full tw-flex-col tw-justify-between" }, s0 = { class: "tw-inline-flex tw-h-6 tw-flex-row tw-items-center" }, n0 = ["src"], a0 = { class: "tw-ml-2 tw-text-sm tw-font-semibold tw-text-white dark:tw-text-dorian-gray-500" }, l0 = { class: "tw-text-xs tw-font-normal tw-text-white dark:tw-text-dorian-gray-500" }, r0 = /* @__PURE__ */ o("div", { class: "tw-inline-flex tw-h-full tw-items-center tw-text-sm tw-font-bold tw-text-white dark:tw-text-dorian-gray-500" }, /* @__PURE__ */ y("Try Now"), -1), i0 = { class: "tw-relative tw-flex tw-flex-col tw-items-center" }, d0 = /* @__PURE__ */ o("div", { class: "tw-text-white dark:tw-text-dorian-gray-500" }, /* @__PURE__ */ y("Powered by TitanHQ"), -1), c0 = {
  key: 0,
  class: "tw-text-white dark:tw-text-dorian-gray-500"
}, K1 = /* @__PURE__ */ w({
  __name: "cl-footer",
  props: {
    logo: {},
    id: { default: "app-footer" },
    products: { default: () => [] },
    version: { default: "" }
  },
  setup(s) {
    const t = s;
    return (e, n) => (a(), l("footer", {
      id: t.id,
      class: "tw-relative tw-bg-[#374b61] tw-px-4 tw-py-8 tw-text-white dark:tw-bg-dorian-gray-100 dark:tw-text-dorian-gray-500"
    }, [
      t.logo || t.products.length ? (a(), l("div", qc, [
        t.logo ? (a(), l("div", Kc, [
          o("img", {
            class: "tw-max-h-[90px] tw-w-auto",
            alt: "company logo",
            src: t.logo
          }, null, 8, Jc)
        ])) : x("", !0),
        o("div", Xc, [
          o("div", Yc, [
            t.products.length > 0 ? (a(), l("div", t0, y("Other Products"))) : x("", !0),
            (a(!0), l(H, null, L(t.products, (d, r) => (a(), l("div", {
              key: r,
              class: "tw-mb-2 tw-h-14 tw-w-[260px] tw-rounded-sm tw-border tw-border-dorian-gray-500/5 tw-bg-[#47647d] tw-p-1.5 dark:tw-bg-white"
            }, [
              o("a", {
                href: d.link,
                "data-test-id": `footer-product-${d.title.toLowerCase()}`,
                target: "_blank",
                class: "tw-inline-flex tw-h-full tw-w-full tw-justify-between"
              }, [
                o("div", o0, [
                  o("div", s0, [
                    o("img", {
                      src: d.icon,
                      class: "tw-h-6 tw-w-auto"
                    }, null, 8, n0),
                    o("span", a0, y(d.title), 1)
                  ]),
                  o("div", l0, y(d.description), 1)
                ]),
                r0
              ], 8, e0)
            ]))), 128))
          ])
        ])
      ])) : x("", !0),
      o("div", i0, [
        d0,
        e.version ? (a(), l("div", c0, y(`v ${t.version}`), 1)) : x("", !0)
      ])
    ], 8, Qc));
  }
}), w0 = { class: "tw-inline-flex tw-h-8 tw-items-center tw-justify-between tw-rounded-2xl tw-border-none tw-bg-secondary-200 tw-pl-2 tw-pr-1.5" }, h0 = { class: "tw-text-base tw-text-dorian-gray-500" }, u0 = { class: "tw-font-bold" }, p0 = { class: "tw-pl-1 tw-font-normal" }, J1 = /* @__PURE__ */ w({
  __name: "cl-active-filter",
  props: {
    label: {},
    value: {},
    withClose: { type: Boolean, default: !0 }
  },
  emits: ["remove"],
  setup(s, { emit: t }) {
    const e = s, n = t, d = () => {
      n("remove");
    };
    return (r, i) => (a(), l("span", w0, [
      o("span", h0, [
        o("span", u0, y(e.label), 1),
        o("span", p0, y(e.value), 1)
      ]),
      e.withClose ? (a(), l("span", {
        key: 0,
        role: "button",
        class: "tw-ml-2 tw-inline-flex tw-h-5 tw-w-5 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-secondary-500 tw-text-white tw-transition-colors hover:tw-bg-secondary-400",
        onClick: d
      }, [
        I(u(Tt), {
          height: "16px",
          width: "16px"
        })
      ])) : x("", !0)
    ]));
  }
}), _0 = { class: "tw-relative" }, f0 = { class: "tw-inline-flex tw-cursor-pointer tw-items-center" }, g0 = /* @__PURE__ */ o("div", { class: "tw-peer tw-relative tw-h-6 tw-w-11 tw-rounded-full tw-bg-dorian-gray-300 after:tw-absolute after:tw-start-[2px] after:tw-top-[2px] after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-secondary-500 peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white peer-focus:tw-outline-none" }, null, -1), b0 = { class: "tw-text-sm tw-font-medium tw-text-dorian-gray-500" }, X1 = /* @__PURE__ */ w({
  __name: "cl-toggle",
  props: {
    value: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(s, { emit: t }) {
    const e = s, { value: n } = P(e), d = C({
      get() {
        return n.value;
      },
      set(i) {
        r("update:value", i);
      }
    }), r = t;
    return (i, c) => (a(), l("div", _0, [
      o("label", f0, [
        D(o("input", {
          "onUpdate:modelValue": c[0] || (c[0] = (h) => d.value = h),
          type: "checkbox",
          class: "tw-peer tw-sr-only"
        }, null, 512), [
          [K, d.value]
        ]),
        g0,
        o("span", b0, [
          f(i.$slots, "default")
        ])
      ])
    ]));
  }
}), v0 = { class: "tw-mb-4 tw-grid tw-grid-cols-1 tw-gap-2" }, m0 = { class: "tw-col-span-1 tw-overflow-x-auto tw-shadow" }, Y1 = /* @__PURE__ */ w({
  __name: "cl-table-wrapper",
  props: {
    className: {}
  },
  setup(s) {
    const t = s, { className: e } = P(t);
    return (n, d) => (a(), l("div", {
      class: p(["tw-relative tw-my-4 tw-p-4", u(e)])
    }, [
      f(n.$slots, "before"),
      o("div", v0, [
        o("div", m0, [
          f(n.$slots, "table")
        ])
      ]),
      f(n.$slots, "after")
    ], 2));
  }
}), th = /* @__PURE__ */ w({
  __name: "cl-table",
  props: {
    className: {}
  },
  setup(s) {
    const t = s, { className: e } = P(t);
    return (n, d) => (a(), l("table", U({
      class: ["tw-w-full tw-rounded tw-text-left tw-text-base tw-shadow dark:tw-border dark:tw-border-solid dark:tw-border-dorian-gray-100/80 dark:tw-shadow-none", u(e)]
    }, n.$attrs), [
      f(n.$slots, "default")
    ], 16));
  }
}), eh = /* @__PURE__ */ w({
  __name: "cl-thead",
  props: {
    className: {}
  },
  setup(s) {
    const t = s, { className: e } = P(t);
    return (n, d) => (a(), l("thead", U({
      class: ["tw-bg-white", u(e)]
    }, n.$attrs), [
      f(n.$slots, "default")
    ], 16));
  }
}), oh = /* @__PURE__ */ w({
  __name: "cl-tbody",
  props: {
    className: {}
  },
  setup(s) {
    const t = s, { className: e } = P(t);
    return (n, d) => (a(), l("tbody", U({ class: u(e) }, n.$attrs), [
      f(n.$slots, "default")
    ], 16));
  }
}), sh = /* @__PURE__ */ w({
  __name: "cl-tr",
  props: {
    tableTarget: { default: "tbody" },
    zebra: { type: Boolean, default: !1 },
    className: { default: void 0 },
    active: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = {
      thead: "",
      tbody: "tw-border-b tw-border-dorian-gray-100/80 tw-h-9 hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100"
    }, { className: n, zebra: d, tableTarget: r, active: i } = P(t), c = C(() => {
      const b = (() => i.value ? "tw-bg-secondary-200" : d.value ? "tw-bg-light" : "tw-bg-white")();
      return [e[r.value], b, n.value];
    });
    return (h, b) => (a(), l("tr", U({ class: c.value }, h.$attrs), [
      f(h.$slots, "default")
    ], 16));
  }
}), nh = /* @__PURE__ */ w({
  __name: "cl-th",
  props: {
    className: {}
  },
  setup(s) {
    const t = s, { className: e } = P(t);
    return (n, d) => (a(), l("th", U({
      class: ["tw-whitespace-nowrap tw-px-2 tw-py-1.5 tw-font-bold", u(e)]
    }, n.$attrs), [
      f(n.$slots, "default")
    ], 16));
  }
}), ah = /* @__PURE__ */ w({
  __name: "cl-td",
  props: {
    className: {}
  },
  setup(s) {
    const t = s, { className: e } = P(t);
    return (n, d) => (a(), l("td", U({
      class: ["tw-whitespace-nowrap tw-px-2 tw-py-1.5 tw-font-normal", u(e)]
    }, n.$attrs), [
      f(n.$slots, "default")
    ], 16));
  }
}), y0 = /* @__PURE__ */ o("div", { class: "tw-w-30 tw-h-5 tw-animate-pulse tw-bg-light" }, null, -1), x0 = [
  y0
], lh = /* @__PURE__ */ w({
  __name: "cl-tr-skeleton",
  props: {
    rows: {},
    className: {}
  },
  setup(s) {
    const t = s, { rows: e } = P(t);
    return (n, d) => (a(!0), l(H, null, L(u(e), (r, i) => (a(), l("tr", {
      key: i,
      class: p(["tw-h-9 tw-border-b tw-border-dorian-gray-100/80 hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100", "tw-bg-white"])
    }, [
      (a(!0), l(H, null, L(r, (c) => (a(), l("td", {
        key: r[c],
        class: "h-2 bg-slate-200 rounded tw-animate-pulse tw-whitespace-nowrap tw-px-2"
      }, x0))), 128))
    ]))), 128));
  }
}), $0 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-up",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, k0 = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), C0 = /* @__PURE__ */ o("path", { d: "M12 5l0 14" }, null, -1), M0 = /* @__PURE__ */ o("path", { d: "M18 11l-6 -6" }, null, -1), B0 = /* @__PURE__ */ o("path", { d: "M6 11l6 -6" }, null, -1), I0 = [
  k0,
  C0,
  M0,
  B0
], z0 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-down",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, T0 = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), H0 = /* @__PURE__ */ o("path", { d: "M12 5l0 14" }, null, -1), S0 = /* @__PURE__ */ o("path", { d: "M18 13l-6 6" }, null, -1), j0 = /* @__PURE__ */ o("path", { d: "M6 13l6 6" }, null, -1), L0 = [
  T0,
  H0,
  S0,
  j0
], V0 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrows-sort",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, P0 = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), A0 = /* @__PURE__ */ o("path", { d: "M3 9l4 -4l4 4m-4 -4v14" }, null, -1), O0 = /* @__PURE__ */ o("path", { d: "M21 15l-4 4l-4 -4m4 4v-14" }, null, -1), D0 = [
  P0,
  A0,
  O0
], rh = /* @__PURE__ */ w({
  __name: "cl-th-sorting",
  props: {
    sortDirection: { type: [Boolean, String] }
  },
  setup(s) {
    const t = s, { sortDirection: e } = P(t);
    return (n, d) => (a(), l("div", {
      class: p([
        u(e) === !1 ? "tw-text-dorian-gray-200" : "tw-text-dorian-gray-500",
        "tw-ml-2"
      ])
    }, [
      u(e) === "asc" ? (a(), l("svg", $0, I0)) : u(e) === "desc" ? (a(), l("svg", z0, L0)) : (a(), l("svg", V0, D0))
    ], 2));
  }
}), N0 = { class: "tw-mr-4 tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start" }, F0 = {
  class: "tw-mr-4 tw-whitespace-nowrap tw-text-sm tw-text-dorian-gray-500",
  for: "row-per-page-select"
}, E0 = ["value", "disabled"], Z0 = ["value"], ih = /* @__PURE__ */ w({
  __name: "cl-table-page-size",
  props: {
    placeholder: {},
    pageSize: {},
    pageSizes: {},
    handlePageSizeChange: { type: Function },
    disabled: { type: Boolean }
  },
  setup(s) {
    const t = s, { placeholder: e, pageSize: n, pageSizes: d, handlePageSizeChange: r, disabled: i } = P(t);
    return (c, h) => (a(), l("div", N0, [
      o("label", F0, y(u(e)), 1),
      o("select", {
        id: "row-per-page-select",
        name: "row-per-page-select",
        class: "tw-focus:border-gray-200 peer tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-solid tw-border-dorian-gray-100/80 tw-bg-white tw-text-sm tw-text-dorian-gray-500 tw-outline-none focus:tw-border-secondary-500 focus:tw-ring-0",
        value: u(n),
        disabled: u(i),
        onChange: h[0] || (h[0] = //@ts-ignore
        (...b) => u(r) && u(r)(...b))
      }, [
        (a(!0), l(H, null, L(u(d), (b) => (a(), l("option", {
          key: b,
          value: b
        }, y(b), 9, Z0))), 128))
      ], 40, E0)
    ]));
  }
}), R0 = {
  class: "tw-inline-flex",
  role: "group"
}, U0 = ["disabled", "data-test-id"], W0 = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, '"Previous Page"', -1), G0 = /* @__PURE__ */ o("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-chevron-left",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ o("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /* @__PURE__ */ o("path", { d: "M15 6l-6 6l6 6" })
], -1), Q0 = [
  W0,
  G0
], q0 = ["disabled", "data-test-id"], K0 = /* @__PURE__ */ o("span", { class: "tw-sr-only" }, '"Next Page"', -1), J0 = /* @__PURE__ */ o("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-chevron-right",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ o("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /* @__PURE__ */ o("path", { d: "M9 6l6 6l-6 6" })
], -1), X0 = [
  K0,
  J0
], dh = /* @__PURE__ */ w({
  __name: "cl-table-basic-pagination",
  props: {
    canPreviousPage: { type: Boolean },
    previousPage: {},
    canNextPage: { type: Boolean },
    nextPage: {},
    disabled: { type: Boolean },
    testId: { default: "cl-table-basic-pagination" }
  },
  setup(s) {
    const t = s, { canPreviousPage: e, previousPage: n, canNextPage: d, nextPage: r, disabled: i } = P(t);
    return (c, h) => (a(), l("div", R0, [
      o("button", {
        type: "button",
        class: "tw-bg-transparent tw-mr-[-1px] tw-rounded-l tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-r disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
        disabled: u(i) || !u(e),
        "data-test-id": `${t.testId}-previous`,
        onClick: h[0] || (h[0] = //@ts-ignore
        (...b) => u(n) && u(n)(...b))
      }, Q0, 8, U0),
      o("button", {
        type: "button",
        class: "tw-bg-transparent tw-ml-[-1px] tw-rounded-r tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-l disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
        disabled: u(i) || !u(d),
        "data-test-id": `${t.testId}-next`,
        onClick: h[1] || (h[1] = //@ts-ignore
        (...b) => u(r) && u(r)(...b))
      }, X0, 8, q0)
    ]));
  }
}), Y0 = { class: "tw-mr-auto tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start" }, tw = { class: "tw-text-sm tw-text-dorian-gray-500" }, ch = /* @__PURE__ */ w({
  __name: "cl-table-pagination-state",
  props: {
    start: {},
    end: {},
    total: {},
    placeholder: {}
  },
  setup(s) {
    const t = s, { start: e, end: n, total: d, placeholder: r } = P(t);
    return (i, c) => (a(), l("div", Y0, [
      o("span", tw, [
        o("span", null, y(`${u(e)} - ${u(n)}`), 1),
        o("span", null, y(` ${u(r)} `), 1),
        o("span", null, y(u(d)), 1)
      ])
    ]));
  }
}), ew = ["disabled"], ow = {
  key: 0,
  id: "set-rows-wrapper",
  class: "tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-p-4 tw-pb-2 tw-shadow-md tw-transition-opacity"
}, wh = /* @__PURE__ */ w({
  __name: "cl-table-column-visibility-toggle",
  props: {
    disabled: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = M(!1), n = () => {
      e.value = !e.value;
    }, d = C(() => t.disabled ? "tw-stroke-dorian-gray-200 tw-cursor-not-allowed" : e.value ? "tw-stroke-secondary-500" : "tw-stroke-dorian-gray-500 tw-transition-colors group-hover:tw-stroke-secondary-500"), r = M(null);
    return W(r, () => {
      e.value = !1;
    }), (i, c) => {
      const h = Ct("cl-icon-tabler-table");
      return a(), l("div", {
        ref_key: "columnSetTooltip",
        ref: r
      }, [
        o("button", {
          class: "tw-group tw-mx-4 tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-dorian-gray-100 tw-pl-4",
          disabled: i.disabled,
          onClick: n
        }, [
          I(h, {
            width: "24",
            height: "24",
            class: p(d.value)
          }, null, 8, ["class"])
        ], 8, ew),
        e.value ? (a(), l("div", ow, [
          f(i.$slots, "default")
        ])) : x("", !0)
      ], 512);
    };
  }
}), sw = ["indeterminate"], hh = /* @__PURE__ */ w({
  __name: "cl-input-checkbox",
  props: {
    indeterminate: { type: Boolean },
    className: {}
  },
  setup(s) {
    const t = s, { indeterminate: e, className: n } = P(t);
    return (d, r) => (a(), l("input", U({
      type: "checkbox",
      class: ["tw-h-5 tw-w-5 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100", u(n)],
      indeterminate: u(e)
    }, d.$attrs), null, 16, sw));
  }
}), nw = { class: "tw-relative tw-w-full" }, aw = { class: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-text-dorian-gray-200" }, lw = ["width", "height"], rw = /* @__PURE__ */ o("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1), iw = /* @__PURE__ */ o("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }, null, -1), dw = /* @__PURE__ */ o("path", { d: "M21 21l-6 -6" }, null, -1), cw = [
  rw,
  iw,
  dw
], ww = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", hw = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", uw = "read-only:tw-cursor-default read-only:tw-bg-dorian-gray-50 read-only:tw-text-dorian-gray-500/50 read-only:tw-outline-none", uh = /* @__PURE__ */ w({
  __name: "cl-input-search",
  props: {
    value: {},
    className: { default: void 0 },
    size: { default: "medium" },
    state: { type: Boolean, default: void 0 }
  },
  emits: ["update:value"],
  setup(s, { expose: t, emit: e }) {
    const n = s, d = {
      small: "tw-text-sm tw-py-1 tw-px-3 tw-pl-9",
      medium: "tw-text-base tw-py-2 tw-px-3 tw-pl-10",
      large: "tw-text-lg tw-py-3 tw-px-3 tw-pl-12"
    }, r = {
      none: "tw-border-dorian-gray-100/80",
      valid: "tw-border-success-500",
      error: "tw-border-danger-500"
    }, i = M(null), c = () => {
      i.value && i.value.focus();
    }, { className: h, size: b, state: m, value: $ } = P(n), v = C(() => [
      d[b.value],
      m.value === void 0 ? r.none : n.state ? r.valid : r.error,
      ww,
      hw,
      uw,
      h.value
    ]), B = C(() => b.value === "small" ? "14" : b.value === "medium" ? "18" : "24"), T = C({
      get() {
        return $.value;
      },
      set(O) {
        st("update:value", O);
      }
    }), st = e;
    return t({
      focus: c
    }), (O, G) => (a(), l("div", nw, [
      D(o("input", U(O.$attrs, {
        ref_key: "searchRef",
        ref: i,
        "onUpdate:modelValue": G[0] || (G[0] = (E) => T.value = E),
        type: "search",
        class: ["tw-block tw-w-full tw-rounded tw-border tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", v.value]
      }), null, 16), [
        [wt, T.value]
      ]),
      o("span", aw, [
        (a(), l("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "icon icon-tabler icon-tabler-search",
          width: B.value,
          height: B.value,
          viewBox: "0 0 24 24",
          "stroke-width": "1.5",
          stroke: "currentColor",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, cw, 8, lw))
      ])
    ]));
  }
}), ph = /* @__PURE__ */ w({
  __name: "cl-input-radio",
  props: {
    modelValue: { type: [String, Number, Boolean] }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: t }) {
    const e = s, n = t, { modelValue: d } = P(e), r = C({
      get() {
        return d.value;
      },
      set(i) {
        n("update:modelValue", i);
      }
    });
    return (i, c) => D((a(), l("input", {
      "onUpdate:modelValue": c[0] || (c[0] = (h) => r.value = h),
      class: "tw-border-dorian-gray-70 tw-my-2 tw-ml-4 tw-mr-2 tw-h-5 tw-w-5 tw-cursor-pointer tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white",
      type: "radio"
    }, null, 512)), [
      [ne, r.value]
    ]);
  }
}), pw = ["data-test-id"], _w = { class: "tw-flex tw-items-center tw-justify-between" }, fw = { key: 0 }, _h = /* @__PURE__ */ w({
  __name: "cl-accordion",
  props: {
    testId: { default: "cl-accordion-toggle-btn" },
    isOpenDefault: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, [e, n] = Ie(t.isOpenDefault);
    return (d, r) => (a(), l("div", null, [
      o("button", {
        class: "tw-block tw-w-full",
        "data-test-id": d.testId,
        onClick: r[0] || (r[0] = (i) => u(n)())
      }, [
        o("div", _w, [
          f(d.$slots, "summary"),
          o("div", null, [
            I(u(ot), {
              class: p(["tw-transition-transform", u(e) ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])
          ])
        ])
      ], 8, pw),
      u(e) ? (a(), l("div", fw, [
        f(d.$slots, "details")
      ])) : x("", !0)
    ]));
  }
});
export {
  _h as ClAccordion,
  J1 as ClActiveFilter,
  P1 as ClBadge,
  A1 as ClBadgeLabel,
  N1 as ClBreadcrumbs,
  ct as ClButton,
  I1 as ClCard,
  T1 as ClCardTrend,
  F1 as ClCheckbox,
  y1 as ClDataTable,
  k1 as ClDataTableDeleteAction,
  x1 as ClDataTableEditAction,
  C1 as ClDataTableMoreAction,
  M1 as ClDataTableMoreActionItem,
  $1 as ClDataTableViewAction,
  S1 as ClDropdown,
  j1 as ClDropdownItem,
  O1 as ClEmailAttachment,
  K1 as ClFooter,
  bw as ClFormGroup,
  mw as ClFormInput,
  vw as ClFormLabel,
  E1 as ClFormRadioGroup,
  Q1 as ClFormSelect,
  G1 as ClFormTextarea,
  R1 as ClHeaderDropdown,
  W1 as ClHeaderDropdownLink,
  U1 as ClHeaderDropdownProduct,
  ut as ClHeading,
  xw as ClHr,
  Iw as ClIconArrowUpRight,
  Bw as ClIconBoxArrowInLeft,
  Mw as ClIconColumnsGap,
  Kw as ClIconEnvelopeAt,
  Jw as ClIconEnvelopeLetter,
  lo as ClIconList,
  Xw as ClIconPaperBoard,
  zw as ClIconPencilSquare,
  c1 as ClIconTableCheck,
  s1 as ClIconTablerAdjustmentsHorizontal,
  o1 as ClIconTablerAlertTriangle,
  d1 as ClIconTablerArchive,
  ia as ClIconTablerArrowDown,
  Ew as ClIconTablerArrowFork,
  Zw as ClIconTablerArrowForkLeft,
  _a as ClIconTablerArrowUp,
  Ow as ClIconTablerBriefcase,
  e1 as ClIconTablerCalendarEvent,
  ot as ClIconTablerChevronDown,
  ma as ClIconTablerChevronLeft,
  It as ClIconTablerChevronRight,
  nl as ClIconTablerCircleCheck,
  Fl as ClIconTablerCircleCheckFilled,
  Yw as ClIconTablerCopy,
  Tw as ClIconTablerDashboard,
  ea as ClIconTablerDotsVertical,
  ys as ClIconTablerDownload,
  Fs as ClIconTablerEdit,
  Nw as ClIconTablerEditCircle,
  h1 as ClIconTablerExternalLink,
  Ts as ClIconTablerFile,
  u1 as ClIconTablerFileTypePdf,
  r1 as ClIconTablerFishHook,
  Hw as ClIconTablerFlag3,
  a1 as ClIconTablerForbid,
  Fw as ClIconTablerHistory,
  Sw as ClIconTablerIconBulb,
  jw as ClIconTablerIconChartBar,
  Ys as ClIconTablerIconEye,
  Lw as ClIconTablerIconRecharging,
  zt as ClIconTablerInfoCircle,
  t1 as ClIconTablerInfoFilled,
  qw as ClIconTablerLifebuoy,
  Qw as ClIconTablerLogout,
  Gw as ClIconTablerMail,
  n1 as ClIconTablerMailCheck,
  Rw as ClIconTablerReportAnalytics,
  i1 as ClIconTablerSchool,
  Ht as ClIconTablerSearch,
  Vw as ClIconTablerSettings,
  Uw as ClIconTablerShieldCheck,
  Ww as ClIconTablerShieldLock,
  p1 as ClIconTablerSparkles,
  _1 as ClIconTablerSparklesHorizontal,
  Rn as ClIconTablerTable,
  Qn as ClIconTablerTrash,
  Wa as ClIconTablerUser,
  l1 as ClIconTablerUserPlus,
  Dw as ClIconTablerWordUp,
  w1 as ClIconTablerWorldCheck,
  Tt as ClIconTablerX,
  hh as ClInputCheckbox,
  ph as ClInputRadio,
  uh as ClInputSearch,
  H1 as ClModal,
  $w as ClP,
  B1 as ClPill,
  kw as ClSidebar,
  b1 as ClSidebarDropdown,
  m1 as ClSidebarDropdownMenuItem,
  v1 as ClSidebarDropdownSearch,
  g1 as ClSidebarNav,
  f1 as ClSidebarNavItemChild,
  Cw as ClSidebarNavItemParent,
  xt as ClSkeleton,
  z1 as ClSkeletonRow,
  yw as ClSpinner,
  q1 as ClStepper,
  D1 as ClSwitcher,
  th as ClTable,
  dh as ClTableBasicPagination,
  wh as ClTableColumnVisibilityToggle,
  ih as ClTablePageSize,
  ch as ClTablePaginationState,
  Y1 as ClTableWrapper,
  Aw as ClTablerIconBuildingSkyscraper,
  Pw as ClTablerIconUsers,
  L1 as ClTabs,
  V1 as ClTabsItem,
  oh as ClTbody,
  ah as ClTd,
  nh as ClTh,
  rh as ClThSorting,
  eh as ClThead,
  Z1 as ClToast,
  X1 as ClToggle,
  St as ClTooltip,
  sh as ClTr,
  lh as ClTrSkeleton
};
//# sourceMappingURL=frontend-component-library.es.js.map
